<template>
    <div id="app" ref="scrollEle">
        <!-- 加载遮罩 -->
        <Loading v-if="isLoading" />
        <div class="top-banner section" v-for="(item, index) in list" :key="index">
            <div class="posi-img">
                <div class="music-box" v-if="item.musicPlay">
                    <p class="title-words">在开始之前，先选择一下陪伴你的背景音乐吧</p>
                    <ul class="music-play-main" id="musicPlayBox">
                        <li class="music-play-item" v-for="(item, index) in musicData" :key="item.name">
                            <div class="music-img-box">
                                <img v-lazy="item.img" alt="" class="music-playbill" :id="`musicPlay${index}`" />
                            </div>
                            <p class="song-name">{{ item.name }}</p>
                            <p class="discription">{{ item.discri }}</p>
                            <MusicAudio
                                v-bind:musicIndex="index"
                                v-bind:audio="item.music"
                                @banHandler="addBanClass"
                                @MarkBackgroundMusic="markBackgroundMusicHandler"
                                @banAllMicroPhone="banAllMicroPhoneHandler"
                                @clearnBackgroundMusic="clearnBackgroundMusicHandler"
                                @markMusicIndex="markMusicIndexHandler"
                            ></MusicAudio>
                            <button>选择</button>
                        </li>
                    </ul>
                    <p class="title-words left">下滑开始观赏线上展览</p>
                </div>
                <img class="wall-photo" v-lazy="`http://www.artgogo.com/online-exhibition/largeimg/${item.backgroundImg}`" />
                <!-- 气泡卡片 小地图位置 -->
                <p class="title-intro" v-if="item.title">{{ item.title }}</p>
                <Mappopover v-bind:mapShow="item.mapVisible" v-bind:microphone="item.microphone" v-bind:mapIcon="item.mapIcon" v-bind:idx="index"> </Mappopover>
                <div v-show="item.microphone" :class="[item.microphone && item.mapIcon ? 'ml' : '', 'microphone', item.ban ? 'ban' : '']">
                    <svg class="icon icon-microphone" aria-hidden="true">
                        <use xlink:href="#icon-microphone"></use>
                    </svg>
                    <!-- 单组轮播 播放语音 -->
                    <Audio
                        v-if="item.audioCont"
                        v-bind:anchorIndex="index"
                        v-bind:audioCont="item.audioCont"
                        v-bind:lyric="item.lyric"
                        v-bind:switchBanner="item.switchBanner"
                        @banHandler="addBanClass"
                        @changeMicrophone="changeMicrophoneState"
                        @resetMicrophone="resetMicrophoneState"
                        @playBackgroundMusic="playBackgroundMusicHandler"
                        @stopBackgroundMusic="stopBackgroundMusicHandler"
                    >
                    </Audio>
                </div>
                <!-- 放大镜 -->
                <Search
                    @changeMask="toshow"
                    v-if="item.carousel || item.peter"
                    v-bind:searchPosMess="item.className || item.classNameOne"
                    v-bind:anchorIndex="index"
                    v-bind:hasHandler="item.hasHandler"
                    v-bind:showFallMess="item.peter"
                    v-bind:hasAudio="item.hasAudio"
                    @playBackgroundMusic="playBackgroundMusicHandler"
                >
                </Search>
                <Search
                    @changeMask="toshow"
                    v-if="item.carouselOne || item.baique"
                    v-bind:anchorIndex="index"
                    v-bind:searchPosMess="item.classNameOne"
                    v-bind:showFallMess="item.baique"
                    v-bind:hasHandler="item.hasHandler"
                >
                </Search>

                <Search
                    @changeMask="toshow"
                    v-if="item.carouselTwo || item.yangdifei"
                    v-bind:anchorIndex="index"
                    v-bind:searchPosMess="item.classNameTwo"
                    v-bind:hasHandler="item.hasHandler"
                    v-bind:showFallMess="item.yangdifei"
                    v-bind:hasAudio="item.hasAudio"
                    @playBackgroundMusic="playBackgroundMusicHandler"
                >
                </Search>

                <!-- 图片集锦区域      -->
                <Artworkalbum v-if="item.artworkAlbum"></Artworkalbum>
            </div>

            <!--  单组轮播部分 -->
            <div v-if="item.carousel" style="width:100%">
                <a-button type="primary" :class="item.className" @click="showDrawer(index)"> <a-icon type="plus" /> </a-button>
                <a-drawer :width="width" :visible="item.visible" :body-style="{ background: 'rgba(0,0,0,0.8)' }" @close="onClose(index)">
                    <div class="slide-box">
                        <img class="back-img" v-lazy="`http://www.artgogo.com/online-exhibition/img/${item.backgroundImg}`"  alt="">
                        <Carousel v-bind:artwork="item.carousel"></Carousel>
                    </div>
                </a-drawer>
            </div>

            <!--  双组轮播部分 -->
            <div v-if="item.carouselOne" style="width:100%">
                <a-button type="primary" :class="item.classNameOne" @click="showDrawerOne(index)"> <a-icon type="plus" /> </a-button>
                <a-drawer :width="width" :visible="item.visibleOne" :body-style="{ background: 'rgba(0,0,0,0.8)' }" @close="onClose(index)">
                    <div class="slide-box">
                        <img class="back-img" v-lazy="`http://www.artgogo.com/online-exhibition/img/${item.backgroundImg}`"  alt="">
                        <Carousel v-bind:artwork="item.carouselOne"></Carousel>
                        <div v-show="item.audioCont1" :class="['microphone', item.ban ? 'ban' : '']">
                            <svg class="icon" aria-hidden="true">
                                <use xlink:href="#icon-microphone"></use>
                            </svg>
                            <!-- 双组轮播 播放语音 -->
                            <Audio
                                v-if="item.audioCont1"
                                v-bind:anchorIndex="index"
                                v-bind:audioCont="item.audioCont1"
                                v-bind:lyric="item.lyric1"
                                v-bind:id="item.classNameOne"
                                v-bind:switchBanner="item.switchBanner"
                                @banHandler="addBanClass"
                                @changeMicrophone="changeMicrophoneState"
                                @resetMicrophone="resetMicrophoneState"
                                @playBackgroundMusic="playBackgroundMusicHandler"
                                @stopBackgroundMusic="stopBackgroundMusicHandler"
                            >
                            </Audio>
                        </div>
                    </div>
                </a-drawer>
            </div>

            <div v-if="item.carouselTwo" style="width:100%">
                <a-button type="primary" :class="item.classNameTwo" @click="showDrawerTwo(index)"> <a-icon type="plus" /> </a-button>
                <a-drawer :width="width" :visible="item.visibleTwo" :body-style="{ background: 'rgba(0,0,0,0.8)' }" @close="onClose(index)">
                    <div class="slide-box">
                        <img class="back-img" v-lazy="`http://www.artgogo.com/online-exhibition/img/${item.backgroundImg}`"  alt="">
                        <Carousel v-bind:artwork="item.carouselTwo"></Carousel>
                        <div v-show="item.audioCont2" :class="['microphone', item.ban2 ? 'ban2' : '']">
                            <svg class="icon" aria-hidden="true">
                                <use xlink:href="#icon-microphone"></use>
                            </svg>
                            <!-- 双组轮播 播放语音 -->
                            <Audio
                                v-if="item.audioCont2"
                                v-bind:anchorIndex="index"
                                v-bind:audioCont="item.audioCont2"
                                v-bind:ban2Class="true"
                                v-bind:lyric="item.lyric2"
                                v-bind:id="item.classNameTwo"
                                v-bind:switchBanner="item.switchBanner"
                                @banHandler="addBanClass"
                                @changeMicrophone="changeMicrophoneState"
                                @resetMicrophone="resetMicrophoneState"
                                @playBackgroundMusic="playBackgroundMusicHandler"
                                @stopBackgroundMusic="stopBackgroundMusicHandler"
                            >
                            </Audio>
                        </div>
                    </div>
                </a-drawer>
            </div>

            <!-- 艺术家名单 -->
            <Mingdan v-if="item.mingdan"></Mingdan>
            <!-- 视频 -->
            <Video v-if="item.hasVideo"
                v-bind:videoUrl="item.videoUrl"
                v-bind:backgroundUrl="item.videoBackgroundImg"
                v-bind:index="index"
                @playBackgroundMusic="playBackgroundMusicHandler"
                @banAllMicroPhone="banAllMicroPhoneHandler">
            </Video>
            <!-- 讯息部分 -->
            <news v-if="item.hasNews"></news>
        </div>
        <!-- 回到顶部 -->
        <BackTop></BackTop>
        <!-- 更换音乐按钮 -->
        <div v-if="musicDom" class="change-music play" @click="changeMusic()">
            <img src="http://www.artgogo.com/online-exhibition/img/change.png" alt="">
        </div>
    </div>
</template>
<style>
.ant-drawer-body {
    padding: 0 !important;
}
.ant-drawer-close {
    font-size: 30px !important;
    color: #fff !important;
    right: 40px!important;
    top: 40px!important;
}
.ant-btn-primary .anticon {
    width: 41px;
    line-height: 2;
    height: 41px;
    opacity: 0;
}
#app {
    width: 100%;
    height: 100%;
    overflow: auto;
}
.section {
    position: relative;
    width: 100%;
    overflow: hidden;
}
.section:after {
    content: '';
    display: block;
    width: 100%;
    height: 0.35rem;
    position: absolute;
    left: 0;
    bottom: 0;
    background: -webkit-linear-gradient(to top, rgba(41, 40, 40, 0.4), rgba(255, 255, 255, 0));
    background: -o-linear-gradient(to top, rgba(41, 40, 40, 0.4), rgba(255, 255, 255, 0));
    background: -moz-linear-gradient(to top, rgba(41, 40, 40, 0.4), rgba(255, 255, 255, 0));
    background: linear-gradient(to top, rgba(41, 40, 40, 0.4), rgba(255, 255, 255, 0));
    background: linear-gradient(to top, rgba(41, 40, 40, 0.4), rgba(255, 255, 255, 0));
}
.posi-img {
    position: relative;
     width: 100%;
    height: 0;
    padding-bottom: 56%;
    overflow: hidden;
}
.title-intro {
    position: absolute;
    color: #212121;
    font-size: 0.1rem;
    left: 50%;
    top: 50%;
    transform: translate(-50%, 5px);
}
.wall-photo {
    width: 100%;
}
.microphone {
    /* position: absolute;
    left: 0.1rem;
    bottom: 0.09rem;
    z-index: 1; */
    position: absolute;
    left: 2%;
    bottom: 3%;
    z-index: 111;
    width: 3.5%;
    height: 6%;
}
.icon-microphone{
    width: 100%!important;
    height: 100%!important;
}
.ban:after,
.ban2:after {
    content: '';
    display: block;
    width: 2px;
    height: 82%;
    background: #fff;
    position: absolute;
    left: 48%;
    top: 0;
    transform: rotate(-56deg);
}
.ml {
    margin-left: 6%;
}
.slide-box {
    position: relative;
    margin: 0 0 0%;
    width: 100%;
    height: 0;
    padding-bottom: 54%;
    background-size: cover;
}
.back-img{
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
}
.slide-box:after {
    content: '';
    display: block;
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0%;
    top: 0;
    background-color: rgba(41, 40, 40, 0.7);
}
.mask {
    position: absolute;
    width: 100%;
    height: 0;
    padding-bottom: 66%;
    left: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.6);
    z-index: 10000;
}

.searchPos4 {
    left: 60%;
    top: 50%;
}
.searchPos5 {
    left: 20%;
    top: 30%;
}
.searchPos6 {
    left: 69%;
    top: 42%;
}
.searchPos7 {
    left: 53%;
    top: 38%;
}
.searchPos8 {
    left: 14%;
    top: 32%;
}
.searchPos9 {
    left: 47%;
    top: 35%;
}
.searchPos10 {
    left: 26%;
    top: 38%;
}
.searchPos10-1 {
    left: 70%;
    top: 43%;
}
.searchPos11 {
    left: 73%;
    top: 22%;
    z-index: 111;
}
.searchPos12 {
    left: 33%;
    top: 34%;
}

.searchPos13 {
    left: 70%;
    top: 34%;
}
.searchPos14 {
    left: 47%;
    top: 34%;
}
.searchPos15 {
    left: 34%;
    top: 39%;
}
.searchPos16 {
    left: 26%;
    top: 37%;
}
.searchPos16-1 {
    left: 67%;
}
.searchPos17 {
    left: 53%;
    top: 35%;
}
.searchPos18 {
    left: 20%;
    top: 15%;
}
.searchPos19 {
    left: 20%;
    top: 15%;
}
.imgPos14 {
    top: 33%;
}
.imgPos15 {
    top: 35%;
}
.music-box {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
}
.title-words {
    margin: 7% 0 4%;
    font-size: 18px;
}
.music-play-main {
    width: 64%;
    height: 50%;
    float: left;
    margin-left: 18%;
    box-sizing: border-box;
}
@media (min-width: 1920px){ 
    .music-play-main{
        height: 35%;
    }
 }
.music-play-item {
    float: left;
    width: 33%;
    height: 100%;
    position: relative;
}
.music-img-box {
    width: 0.9rem;
    height: 0.9rem;
    border-radius: 100%;
    overflow: hidden;
    margin: 0 auto 0.2rem;
    -webkit-box-shadow: 4px 4px 15px 0px rgba(0,0,0,0.5);
    box-shadow: 4px 4px 15px 0px rgba(0,0,0,0.5);
}
.audio-player {
    position: absolute;
    left: 0;
    bottom: 0;
    height: 100%;
    width: 100%;
    margin: 0;
}
.music-playbill {
    width: 100%;
    height: 100%;
}
.play {
    animation: turn 4s linear infinite;
}
@keyframes turn {
    0% {
        -webkit-transform: rotate(0deg);
    }
    25% {
        -webkit-transform: rotate(90deg);
    }
    50% {
        -webkit-transform: rotate(180deg);
    }
    75% {
        -webkit-transform: rotate(270deg);
    }
    100% {
        -webkit-transform: rotate(360deg);
    }
}
.music-play-item p {
    width: 110%;
    font-size: 0.1rem;
    transform: scale(0.8);
    margin-left: -4%;
}
.music-play-item button {
    width: 40%;
    background: #fff;
    border: 1px solid #e2e2e2;
    border-radius: 6px;
    font-size: 0.1rem;
    line-height: 0.16rem;
    position: absolute;
    left: 29%;
    bottom: 0;
}
.left {
    position: relative;
    float: left;
    text-align: center;
    width: 100%;
}
.left:after {
    content: '';
    display: block;
    position: absolute;
    background: url('http://www.artgogo.com/online-exhibition/img/down.png') no-repeat;
    left: 39%;
    top: 0;
    width: 0.2rem;
    height: 0.2rem;
    background-size: 0.2rem;
}
.change-music{
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    background-color: rgba(0, 0, 0, 0.5);
    font-size: 14px;
    font-variant: tabular-nums;
    line-height: 1.5;
    list-style: none;
    font-feature-settings: 'tnum';
    position: fixed;
    right: 100px;
    bottom: 110px;
    z-index: 10;
    width: 40px;
    height: 40px;
    cursor: pointer;
    border-radius: 100%;
}
.change-music img{
    width: 100%;

}
.tuodiantu{
    width: 100% !important;
    height: 100% !important;
}
</style>
<script>
import Mappopover from './Mappopover.vue';
import Carousel from './Carousel.vue';
import Search from './Search.vue';
import BackTop from './Backtop.vue';
import Zhanyan from './Zhanyan.vue';
import Mingdan from './Mingdan.vue';
import Loading from './Loading.vue';
import Video from './Video.vue';
import Artworkalbum from './Artworkalbum.vue';
import Audio from './Audio.vue';
import MusicAudio from './MusicAudio.vue';
import Drawer from './Drawer.vue';
import News from './News.vue'

export default {
    components: {
        Mappopover,
        Carousel,
        Search,
        BackTop,
        Zhanyan,
        Mingdan,
        Loading,
        Video,
        Artworkalbum,
        Audio,
        MusicAudio,
        Drawer,
        News
    },
    data() {
        return {
            width: '100%',
            showFull: false,
            isLoading: true,
            musicDom: null,
            backgroundMusicIndex:0,
            curBan: '',
            preLoadingImg: ['http://www.artgogo.com/online-exhibition/img/1-1.jpg', 'http://www.artgogo.com/online-exhibition/img/1-2.jpg'],
            musicData: [
                {
                    name: 'NOWË - Under the Sun',
                    discri: 'Vlog No Copyright Music',
                    img: 'http://www.artgogo.com/online-exhibition/img/nu7pay_coverartmanual.jpg',
                    music: ['http://www.artgogo.com/online-exhibition/haipai-music/NOWE-UnderTheSun.mp3'],
                },
                {
                    name: '[China Electro] China-P',
                    discri: 'Morocco No Copyright',
                    img: 'http://www.artgogo.com/online-exhibition/img/ChinaPcover.png',
                    music: ['http://www.artgogo.com/online-exhibition/haipai-music/13[ChinaElectro]China-P.mp3'],
                },
                {
                    name: 'Self-Control',
                    discri: 'Revival Music',
                    img: 'http://www.artgogo.com/online-exhibition/img/coverbrain.png',
                    music: ['http://www.artgogo.com/online-exhibition/haipai-music/Self-Control.mp3'],
                },
            ],
            list: [
                {
                    backgroundImg: '1-1.jpg',
                    mapVisible: false,
                    microphone: false,
                    mapIcon: false,
                    MaskShow: false,
                    title: '欢迎光临 艺高高的线上展览',
                },
                {
                    backgroundImg: '1-2.jpg',
                    mapVisible: false,
                    microphone: false,
                    mapIcon: false,
                    MaskShow: false,
                    musicPlay: true,
                },
                 {
                    backgroundImg: '5.jpg',
                    mapVisible: false,
                    microphone: false,
                    mapIcon: false,
                    MaskShow: false
                },
                {
                    backgroundImg: '1.jpg',
                    mapVisible: false,
                    microphone: true,
                    ban: true,
                    audioCont: ['http://www.artgogo.com/online-exhibition/haipai-music/cao-1.m4a'],
                    switchBanner: false,
                    lyric: [
                        {
                            time: '01',
                            words: '来来来 欢迎大家',
                        },
                        {
                            time: '02',
                            words: '欢迎大家来到同心防疫守护你我的这个',
                        },
                        {
                            time: '06',
                            words: '很有意思的展览',
                        },
                        {
                            time: '08',
                            words: '我是艺高高创始人曹启泰',
                        },
                        {
                            time: '010',
                            words: '也是这次的策展人',
                        },
                    ],
                    mapIcon: true,
                    MaskShow: true,
                },
                {
                    backgroundImg: '2.jpg',
                    mapVisible: false,
                    microphone: true,
                    audioCont: ['http://www.artgogo.com/online-exhibition/haipai-music/cao-2.m4a'],
                    switchBanner: false,
                    ban: true,
                    mapIcon: false,
                    MaskShow: true,
                    lyric: [
                        {
                            time: '01',
                            words: '做展览就要有一个心里的想法',
                        },
                        {
                            time: '03',
                            words: '我们用逆时针其实是在告诉你-逆行',
                        },
                        {
                            time: '06',
                            words: '我们从土黄色一路去到光明的粉红色',
                        },
                        {
                            time: '09',
                            words: '象征着“未来会来”',
                        },
                    ],
                },
                {
                    backgroundImg: '3.jpg',
                    mapVisible: false,
                    microphone: false,
                    mapIcon: false,
                    MaskShow: true,
                    zhanyan: true,
                },
                {
                    backgroundImg: '4.jpg',
                    mapVisible: false,
                    microphone: true,
                    ban: true,
                    lyric: [
                        {
                            time: '01',
                            words: '在你一进门会看到的这第一个板块',
                        },
                        {
                            time: '04',
                            words: '你会看到在疫情期间我们做出的雕塑品',
                        },
                        {
                            time: '07',
                            words: '但是请你顺着右边走',
                        },
                        {
                            time: '09',
                            words: '但是当左边回来',
                        },
                        {
                            time: '10',
                            words: '请你写下你的“确定”',
                        },
                    ],
                    audioCont: ['http://www.artgogo.com/online-exhibition/haipai-music/cao-3.m4a'],
                    switchBanner: false,
                    mapIcon: true,
                    MaskShow: true,
                    className: 'searchPos4',
                    visible: false,
                    carousel: [
                        {
                            num: 65,
                            artist: '郭志鹏',
                            city: '上海',
                            title: '中兰山',
                            size: '65*50*30cm',
                            caizhi: '综合材料雕塑',
                            year: 2020,
                            words: '用最熟悉的方式表达对抗疫一线的最可爱的人致敬！歌颂他们品格如花中君子般灿、绽放！',
                            href: 'http://www.artgogo.com/yishupin/2020-2-11_1581414292647.shtml',
                            img: 'http://www.artgogo.com/images/2020/2/11/1581414236matogpic8_a.jpg',
                        },
                        {
                            num: 66,
                            artist: '郭志鹏',
                            city: '上海',
                            title: '一起隔离的小伙伴们…',
                            size: null,
                            caizhi: '综合材料',
                            year: 2020,
                            words: '当我雕琢了你们的时候，你们一起雕琢了我。',
                            href: 'http://www.artgogo.com/yishupin/2020-5-15_1589531532662.shtml',
                            img: 'http://www.artgogo.com/yishupin/images/2020/5/15/20205151589539433257_394_a.jpg',
                        },
                        {
                            num: 76,
                            artist: '童振刚',
                            city: '北京',
                            title: '诱惑的烦恼',
                            size: '5*5*40cm*5',
                            caizhi: '铜质雕塑',
                            year: 2014,
                            words: '塑造出神态各异的顽主形象，伫立于都市林立高楼间，构成一幅别样的景致',
                            href: 'http://www.artgogo.com/yishupin/2014-11-20_1416491582922.shtml',
                            img: 'http://www.artgogo.com/images/2014/11/20/14164914971140065490_a.jpg',
                        },
                        {
                            num: 77,
                            artist: '童振刚',
                            city: '北京',
                            title: '不合作状态 第四组',
                            size: '7*6*23cm*4',
                            caizhi: '铜质雕塑',
                            year: 2015,
                            words: '塑造出神态各异的顽主形象，伫立于都市林立高楼间，构成一幅别样的景致',
                            href: 'http://www.artgogo.com/yishupin/2019-1-18_1547792135519.shtml',
                            img: 'http://www.artgogo.com/images/2019/1/18/1547792075rmatolphs_a.jpg',
                        },
                    ],
                },
                {
                    backgroundImg: '6.jpg',
                    mapVisible: false,
                    microphone: false,
                    mapIcon: true,
                    MaskShow: true,
                    className: 'searchPos5',
                    visible: false,
                    carousel: [
                        {
                            num: 7,
                            artist: '谯梁',
                            city: '四川',
                            title: '希望',
                            size: '26*18cm',
                            caizhi: '纸面水彩',
                            year: 2020,
                            words: '疫情来临，我们都在居家隔离。只有医护工作者选择逆向而行，战斗在一线。成为大家心中最可爱的人。',
                            href: 'http://www.artgogo.com/yishupin/2020-2-13_15815891672.shtml',
                            img: 'http://www.artgogo.com/images/2020/2/13/1581589010ratoypi94_a.jpg',
                        },
                        {
                            num: 1,
                            artist: '杨明',
                            city: '成都',
                            title: '最美的天使',
                            size: '50*70cm',
                            caizhi: '布面丙烯',
                            year: 2020,
                            words: '当摘下口罩的一瞬间，一切付出和辛劳都深深地印在了美丽的脸庞，这就是我们敬佩的白衣天使',
                            href: 'http://www.artgogo.com/yishupin/2020-2-17_1581915849448.shtml',
                            img: 'http://www.artgogo.com/images/2020/2/17/1581914282atolyhic3_a.jpg',
                        },
                        {
                            num: 2,
                            artist: '杨明',
                            city: '成都',
                            title: '最美的天使1',
                            size: '60*80cm',
                            caizhi: '布面丙烯',
                            year: 2020,
                            words: '冲在抗疫前沿的白衣天使们，为了全身心投入到抗疫之中，剪掉了心爱的长发，露出的是布满血丝和凹陷的双眼。',
                            href: 'http://www.artgogo.com/yishupin/2020-2-17_1581915853700.shtml',
                            img: 'http://www.artgogo.com/images/2020/2/17/1581914291dertlhs27_a.jpg',
                        },
                        {
                            num: 3,
                            artist: '杨明',
                            city: '成都',
                            title: '对峙',
                            size: '80*60cm',
                            caizhi: '布面丙烯',
                            year: 2020,
                            words: '你们是面对面的在和病毒作斗争，不是你死就是我活。你们为了更多人的生命安危和家庭幸福义无反顾的冲在了和病毒作斗争的最前列。',
                            href: 'http://www.artgogo.com/yishupin/2020-2-17_1581915843951.shtml',
                            img: 'http://www.artgogo.com/images/2020/2/17/1581914273dlphcs276_a.jpg',
                        },
                        {
                            num: 5,
                            artist: '迟宝绿',
                            city: '上海',
                            title: '变异',
                            size: '80*80cm',
                            caizhi: '布面油画',
                            year: 2020,
                            words:
                                ' 这一系列的创作变化是我眼中的病毒疫情以及舆论衍生出来的。 最终落在动物的本体上，一只看不清的变异动物，害怕的，不知道自己是什么，如同周遭的我们。可以说是人们用网络暴力和虚假的疫情消息一手造成了这一切',
                            href: 'http://www.artgogo.com/yishupin/2020-2-16_1581831835155.shtml',
                            img: 'http://www.artgogo.com/images/2020/2/16/1581831782eatoics73_a.jpg',
                        },
                        {
                            num: 6,
                            artist: '庄晓璐',
                            city: '上海',
                            title: '上海大小姐·天使',
                            size: '34*45cm',
                            caizhi: '布面数码版画',
                            year: 2020,
                            words: '我相信艺术是可以向人们传达温暖、信念和力量的。',
                            href: 'http://www.artgogo.com/yishupin/2020-2-11_1581414930927.shtml',
                            img: 'http://www.artgogo.com/images/2020/2/11/1581414855rtolyp827_a.jpg',
                        },
                        {
                            num: 63,
                            artist: '孔龙震',
                            city: '厦门',
                            title: '震汉先生的2020年～口罩',
                            size: '30*40cm',
                            caizhi: '布面丙烯',
                            year: 2020,
                            words: '疫情 这件历史大事件的时代背景下的一位普通人的生活日常与心情！记录自己的生活与心情  ',
                            href: 'http://www.artgogo.com/yishupin/2020-2-12_158150298746.shtml',
                            img: 'http://www.artgogo.com/images/2020/2/12/1581502605emaolyi84_a.jpg',
                        },
                        {
                            num: 57,
                            artist: '孔龙震',
                            city: '厦门',
                            title: '震汉先生的2020年～将军',
                            size: '60*80cm',
                            caizhi: '布面丙烯',
                            year: 2020,
                            words: '疫情 这件历史大事件的时代背景下的一位普通人的生活日常与心情！记录自己的生活与心情  ',
                            href: 'http://www.artgogo.com/yishupin/2020-2-12_1581502984269.shtml',
                            img: 'http://www.artgogo.com/images/2020/2/12/1581502605emtohic85_a.jpg',
                        },
                        {
                            num: 58,
                            artist: '孔龙震',
                            city: '厦门',
                            title: '震汉先生的2020年～胜利日',
                            size: '100*80cm',
                            caizhi: '布面丙烯',
                            year: 2020,
                            words: '当我们能摘下口罩自由呼吸的时候 便是我们的胜利之日  我们终将会赢得这场战争   与魔界的战争',
                            href: 'http://www.artgogo.com/yishupin/2020-2-12_1581502994919.shtml',
                            img: 'http://www.artgogo.com/images/2020/2/12/1581502608emaois718_a.jpg',
                        },
                        {
                            num: 130,
                            artist: '司意菲 Effie ',
                            city: '上海',
                            title: '等海',
                            size: null,
                            caizhi: '综合材料装置',
                            year: 2020,
                            words:
                                '“每个人一定都会有这样一件物品，它虽然平凡，但却是属于个人的2020记忆。”突如其来的疫情打乱了很多人的行程计划，航班取消旅行受阻，取消了上半年的潜水计划， 9月的船宿也注定延期，为了这一年新买的装备，突然没有了用武之地，反而成了家中的新摆设。但每次看到它们，心中就仍有期待，期待那一天，可以再次出发。相信每个人一定都会有这样一件物品或一件事情，它虽然平凡，但却是属于个人的2020记忆。作品呈现上：在每一件物品上挂上一个标签牌，写着上一次使用日期，原定使用日期，划掉后写计划使用日期，体现计划的改变。',
                            href: 'http://www.artgogo.com/yishupin/2020-5-14_1589466778180.shtml',
                            img: 'http://www.artgogo.com/yishupin/images/2020/5/19/20205191589867225306_394_a.jpg',
                        },
                    ],
                },
                {
                    backgroundImg: '8.jpg',
                    mapVisible: false,
                    microphone: false,
                    mapIcon: true,
                    MaskShow: true,
                    className: 'searchPos6',
                    visible: false,
                    carousel: [
                        {
                            num: 62,
                            artist: '孔龙震',
                            city: '厦门',
                            title: '震汉先生的2020年～不静',
                            size: '40*50cm',
                            caizhi: '布面丙烯',
                            year: 2020,
                            words: '疫情 这件历史大事件的时代背景下的一位普通人的生活日常与心情！记录自己的生活与心情  ',
                            href: 'http://www.artgogo.com/yishupin/2020-2-12_1581502973579.shtml',
                            img: 'http://www.artgogo.com/images/2020/2/12/1581502602etopi6954_a.jpg',
                        },
                        {
                            num: 61,
                            artist: '孔龙震',
                            city: '厦门',
                            title: '震汉先生的2020年～回眸',
                            size: '40*50cm',
                            caizhi: '布面丙烯',
                            year: 2020,
                            words: '疫情 这件历史大事件的时代背景下的一位普通人的生活日常与心情！记录自己的生活与心情  ',
                            href: 'http://www.artgogo.com/yishupin/2020-2-12_1581502980209.shtml',
                            img: 'http://www.artgogo.com/images/2020/2/12/1581502604drmatys90_a.jpg',
                        },
                        {
                            num: 56,
                            artist: '孔龙震',
                            city: '厦门',
                            title: '震汉先生的2020年～赏月',
                            size: '60*80cm',
                            caizhi: '布面丙烯',
                            year: 2020,
                            words: '疫情 这件历史大事件的时代背景下的一位普通人的生活日常与心情！记录自己的生活与心情  ',
                            href: 'http://www.artgogo.com/yishupin/2020-2-12_1581502990452.shtml',
                            img: 'http://www.artgogo.com/images/2020/2/12/1581502607dmogcs386_a.jpg',
                        },
                        {
                            num: 59,
                            artist: '孔龙震',
                            city: '厦门',
                            title: '震汉先生的2020年～等花开',
                            size: '80*100cm',
                            caizhi: '布面丙烯',
                            year: 2020,
                            words: '疫情 这件历史大事件的时代背景下的一位普通人的生活日常与心情！记录自己的生活与心情  ',
                            href: 'http://www.artgogo.com/yishupin/2020-2-12_1581502976290.shtml',
                            img: 'http://www.artgogo.com/images/2020/2/12/1581502603dragyi839_a.jpg',
                        },
                        {
                            num: 60,
                            artist: '孔龙震',
                            city: '厦门',
                            title: '震汉先生的2020年～无事',
                            size: '80*100cm',
                            caizhi: '布面丙烯',
                            year: 2020,
                            words: '疫情 这件历史大事件的时代背景下的一位普通人的生活日常与心情！记录自己的生活与心情  ',
                            href: 'http://www.artgogo.com/yishupin/2020-2-12_158150299743.shtml',
                            img: 'http://www.artgogo.com/images/2020/2/12/1581502609emagypic4_a.jpg',
                        },
                        {
                            num: 64,
                            artist: '孔龙震',
                            city: '厦门',
                            title: '震汉先生的2020年～情人节',
                            size: '60*120cm',
                            caizhi: '布面丙烯',
                            year: 2020,
                            words: '疫情 这件历史大事件的时代背景下的一位普通人的生活日常与心情！记录自己的生活与心情  ',
                            href: 'http://www.artgogo.com/yishupin/2020-5-15_1589526628518.shtml',
                            img: 'http://www.artgogo.com/images/2020/5/15/1589526579datoglcs4_a.jpg',
                        },
                        {
                            num: 52,
                            artist: '刘秀真',
                            city: '上海',
                            title: '上下一心同作战，众志成城抗疫情',
                            size: '38*38cm',
                            caizhi: '纸面国画',
                            year: 2020,
                            words: '病毒无情人有情，只有上下一心、众志成城，时刻不能松懈，方能战胜疫情，取得最后的胜利。',
                            href: 'http://www.artgogo.com/yishupin/2020-3-13_1584075483862.shtml',
                            img: 'http://www.artgogo.com/images/2020/3/13/1584075425dmathis28_a.jpg',
                        },
                        {
                            num: 53,
                            artist: '刘秀真',
                            city: '上海',
                            title: '战疫必胜',
                            size: '38*38cm',
                            caizhi: '纸面国画',
                            year: 2020,
                            words: '没有人生来就是英雄，总有人用平凡成就伟大，致敬迎难而上的白衣天使，我们一起加油！',
                            href: 'http://www.artgogo.com/yishupin/2020-3-13_1584075604109.shtml',
                            img: 'http://www.artgogo.com/images/2020/3/13/1584075559dtoghcs25_a.jpg',
                        },
                        {
                            num: 54,
                            artist: '刘秀真',
                            city: '上海',
                            title: '逆行者守护神',
                            size: '38*38cm',
                            caizhi: '纸面国画',
                            year: 2020,
                            words: '逆行者，不是没有恐惧，而是心怀恐惧，却仍然鼓足勇气奋进！正是你们这一群逆行者，成为了我们的保护神',
                            href: 'http://www.artgogo.com/yishupin/2020-3-13_1584076173274.shtml',
                            img: 'http://www.artgogo.com/images/2020/3/13/1584076135emtogls47_a.jpg',
                        },
                    ],
                },
                {
                    backgroundImg: '10.jpg',
                    mapVisible: false,
                    microphone: false,
                    mapIcon: false,
                    MaskShow: true,
                    hasVideo: true,
                    videoBackgroundImg:'http://www.artgogo.com/online-exhibition/img/10.jpg',
                    videoUrl:'http://www.artgogo.com/online-exhibition/mp4/future.mp4',
                },
                {
                    backgroundImg: '11.jpg',
                    mapVisible: false,
                    microphone: false,
                    mapIcon: true,
                    MaskShow: true,
                    className: 'searchPos7',
                    visible: false,
                    carousel: [
                        {
                            num: 71,
                            artist: '万雨尘',
                            city: '上海',
                            title: '我知道你很难过，但这一切都不是你的错',
                            size: '46*35cm',
                            caizhi: '纸面油画',
                            year: 2020,
                            words: '在疫情期，每个人都被灾难的悲痛所感染，难以避免地陷入混乱与悲伤。蓝色房间里的无根之花，是这混乱内心的安慰。',
                            href: 'http://www.artgogo.com/yishupin/2020-3-30_1585537935478.shtml',
                            img: 'http://www.artgogo.com/images/2020/3/30/1585537900matglhis0_a.jpg',
                        },
                        {
                            num: 12,
                            artist: 'BLKcross',
                            city: '上海',
                            title: '自由',
                            size: '101*67cm',
                            caizhi: '数码摄影',
                            year: 2020,
                            words: '没有戴口罩，呼吸着新鲜空气的骑车大叔，何不是一位自由的追随者，在社会主义核心价值观前，奔向自由！',
                            href: 'http://www.artgogo.com/yishupin/2020-3-18_1584508964909.shtml',
                            img: 'http://www.artgogo.com/images/2020/3/18/1584508736ealhis160_a.jpg',
                        },
                        {
                            num: 13,
                            artist: 'BLKcross',
                            city: '上海',
                            title: '救命恩人',
                            size: '101*67cm',
                            caizhi: '数码摄影',
                            year: 2020,
                            words: '凌乱的头发，坚定的眼神，不取的意志，对，这就是我的救命恩人：外卖小哥没错！ ',
                            href: 'http://www.artgogo.com/yishupin/2020-3-18_1584508952383.shtml',
                            img: 'http://www.artgogo.com/images/2020/3/18/1584508731derglyi87_a.jpg',
                        },
                        {
                            num: 14,
                            artist: 'BLKcross',
                            city: '上海',
                            title: '春忙',
                            size: '101*67cm',
                            caizhi: '数码摄影',
                            year: 2020,
                            words: '在柳叶的倒影下，满载货物的助动车，戴着口罩头盔的人，为生活而忙碌',
                            href: 'http://www.artgogo.com/yishupin/2020-3-18_158450895839.shtml',
                            img: 'http://www.artgogo.com/images/2020/3/18/1584508733lypics952_a.jpg',
                        },
                        {
                            num: 8,
                            artist: 'Kristoffer Kullengren',
                            city: '瑞典（现居日本）',
                            title: 'Future Uncertain',
                            size: '98*80cm',
                            caizhi: '布面丙烯',
                            year: ' ',
                            words: ' 未来的不确定与在不确定中寻找重生/重建/重构的希望的对比，并在确定与不确定中寻求一种平衡',
                            href: 'http://www.artgogo.com/yishupin/2020-3-25_1585107489774.shtml',
                            img: 'http://www.artgogo.com/images/2020/3/25/1585106918dragics16_a.jpg',
                        },
                        {
                            num: 9,
                            artist: 'Kristoffer Kullengren',
                            city: '瑞典,（现居日本）',
                            title: 'Certainty',
                            size: '98*72cm',
                            caizhi: '纸面水彩',
                            year: null,
                            words: ' 未来的不确定与在不确定中寻找重生/重建/重构的希望的对比，并在确定与不确定中寻求一种平衡',
                            href: 'http://www.artgogo.com/yishupin/2020-5-9_1588999446483.shtml',
                            img: 'http://www.artgogo.com/images/2020/5/9/1588999373toglics98_a.jpg',
                        },
                        {
                            num: 10,
                            artist: 'Kristoffer Kullengren',
                            city: '瑞典,（现居日本）',
                            title: 'Rebirth',
                            size: '80*68cm',
                            caizhi: '布面丙烯',
                            year: null,
                            words: '对人的生与死的理解，如果死对所有人都确定，那生，虽不确定，但是否会因为这样的不确定，让人生充满多样，不同与美好',
                            href: 'http://www.artgogo.com/yishupin/2020-5-9_1588999353461.shtml',
                            img: 'http://www.artgogo.com/images/2020/5/9/1588999291detolp968_a.jpg',
                        },
                        {
                            num: 11,
                            artist: 'Kristoffer Kullengren',
                            city: '瑞典,（现居日本）',
                            title: 'Uncertainty',
                            size: '98*72cm',
                            caizhi: '纸面水彩',
                            year: 2017,
                            words: ' 未来的不确定与在不确定中寻找重生/重建/重构的希望的对比，并在确定与不确定中寻求一种平衡',
                            href: 'http://www.artgogo.com/yishupin/2020-5-9_1588999279843.shtml',
                            img: 'http://www.artgogo.com/images/2020/5/9/1588999025dertyi127_a.jpg',
                        },
                    ],
                },
                {
                    backgroundImg: '12.jpg',
                    mapVisible: false,
                    microphone: false,
                    ban: true,
                    ban2: true,
                    audioCont1: ['http://www.artgogo.com/online-exhibition/haipai-music/liangnanwangshuai.mp3'],
                    audioCont2: ['http://www.artgogo.com/online-exhibition/haipai-music/gengxiaogang.m4a'],
                    lyric1: [
                        {
                            time: '01',
                            words: '大家好 我是梁南',
                        },
                        {
                            time: '03',
                            words: '《金色晨光与隔离的色彩》',
                        },
                        {
                            time: '05',
                            words: '这幅画是我在三月份开始创作',
                        },
                        {
                            time: '08',
                            words: '四月份创作结束的',
                        },
                        {
                            time: '11',
                            words: '希望大家在彻底面对自己的时候',
                        },
                        {
                            time: '14',
                            words: '终究可以露出微笑',
                        },
                        {
                            time: '17',
                            words: '隔离只是为了让我们更好的相聚',
                        },
                        {
                            time: '21',
                            words: '大家好 我是王帅 ',
                        },
                        {
                            time: '23',
                            words: '这次展览的三万线系列代表着生命三万天',
                        },
                        {
                            time: '27',
                            words: '提醒着我们应该认真面对生活 ',
                        },
                        {
                            time: '30',
                            words: '而班吉哈的阳光这组系列作品',
                        },
                        {
                            time:'32',
                            words:'更是象征着生命的顽强'
                        },
                        {
                            time: '34',
                            words: '这个特殊的时期相信',
                        },
                        {
                            time: '36',
                            words: '未来会来',
                        },
                    ],
                    lyric2: [
                        {
                            time: '01',
                            words: '大家好 我是耿小刚',
                        },
                        {
                            time: '03',
                            words: '这次展出的作品是隔离日志 ',
                        },
                        {
                            time: '05',
                            words: '希望大家关注',
                        },
                        {
                            time: '08',
                            words: '谢谢',
                        },
                    ],
                    mapIcon: true,
                    MaskShow: true,
                    classNameOne: 'searchPos8',
                    classNameTwo: 'searchPos9',
                    visibleOne: false,
                    visibleTwo: false,
                    carouselOne: [
                        {
                            num: 51,
                            artist: '梁南',
                            city: '太原',
                            title: '金色晨光与隔离的色彩',
                            size: '56*42cm',
                            caizhi: '纸面综合材料',
                            year: 2020,
                            words:
                                '每一笔单色都成独立之状，特殊时期的特殊日子给大家一个完全独立，彻底面对自己，与自己交谈独处的机会，也是人生的一种独特颜色。人生总会悲伤，望你我不忘微笑向上。',
                            href: 'http://www.artgogo.com/yishupin/2020-4-16_1587008693583.shtml',
                            img: 'http://www.artgogo.com/images/2020/4/16/1587008634rmthis342_a.jpg',
                        },
                        {
                            num: 99,
                            artist: '王帅',
                            city: '河北',
                            title: '三万线系列1',
                            size: '70*70cm',
                            caizhi: '布面油画',
                            year: 2019,
                            words: ' 三幅细胞宇宙正如和谐的社会，这是爱的汇集',
                            href: 'http://www.artgogo.com/yishupin/2020-5-7_1588826441740.shtml',
                            img: 'http://www.artgogo.com/images/2020/5/7/1588826232deatohs30_a.jpg',
                        },
                        {
                            num: 100,
                            artist: '王帅',
                            city: '河北',
                            title: '三万线系列2',
                            size: '70*70cm',
                            caizhi: '布面油画',
                            year: 2019,
                            words: ' 三幅细胞宇宙正如和谐的社会，这是爱的汇集',
                            href: 'http://www.artgogo.comyishupin/2020-5-7_1588826500340.shtml',
                            img: 'http://www.artgogo.com/images/2020/5/7/1588826459drgpc2424_a.jpg',
                        },
                        {
                            num: 101,
                            artist: '王帅',
                            city: '河北',
                            title: '三万线系列3',
                            size: '70*70cm',
                            caizhi: '布面油画',
                            year: 2019,
                            words: ' 三幅细胞宇宙正如和谐的社会，这是爱的汇集',
                            href: 'http://www.artgogo.com/yishupin/2020-5-7_1588826561700.shtml',
                            img: 'http://www.artgogo.com/images/2020/5/7/1588826519rlyphis64_a.jpg',
                        },
                        {
                            num: 102,
                            artist: '王帅',
                            city: '河北',
                            title: '班吉哈的阳光1',
                            size: '29.7*21cm',
                            caizhi: '纸面插画',
                            year: 2020,
                            words: '看似灰色地带的生物却富有积极的生命力量',
                            href: 'http://www.artgogo.com/yishupin/2020-5-7_1588826638988.shtml',
                            img: 'http://www.artgogo.com/images/2020/5/7/1588826575eratoyc71_a.jpg',
                        },
                        {
                            num: 103,
                            artist: '王帅',
                            city: '河北',
                            title: '班吉哈的阳光2',
                            size: '29.7*21cm',
                            caizhi: '纸面插画',
                            year: 2020,
                            words: '看似灰色地带的生物却富有积极的生命力量',
                            href: 'http://www.artgogo.com/yishupin/2020-5-7_1588826760293.shtml',
                            img: 'http://www.artgogo.com/images/2020/5/7/1588826695tolpcs527_a.jpg',
                        },
                        {
                            num: 104,
                            artist: '王帅',
                            city: '河北',
                            title: '班吉哈的阳光3',
                            size: '29.7*21cm',
                            caizhi: '纸面插画',
                            year: 2020,
                            words: '看似灰色地带的生物却富有积极的生命力量',
                            href: 'http://www.artgogo.com/yishupin/2020-5-7_1588826854434.shtml',
                            img: 'http://www.artgogo.com/images/2020/5/7/1588826783rmtghc745_a.jpg',
                        },
                        {
                            num: 105,
                            artist: '王帅',
                            city: '河北',
                            title: '班吉哈的阳光4',
                            size: '29.7*21cm',
                            caizhi: '纸面插画',
                            year: 2020,
                            words: '看似灰色地带的生物却富有积极的生命力量',
                            href: 'http://www.artgogo.com/yishupin/2020-5-7_1588827037846.shtml',
                            img: 'http://www.artgogo.com/images/2020/5/7/1588826898dmglhc271_a.jpg',
                        },
                        {
                            num: 106,
                            artist: '王帅',
                            city: '河北',
                            title: '班吉哈的阳光5',
                            size: '29.7*21cm',
                            caizhi: '纸面插画',
                            year: 2020,
                            words: '看似灰色地带的生物却富有积极的生命力量',
                            href: 'http://www.artgogo.com/yishupin/2020-5-7_1588827236602.shtml',
                            img: 'http://www.artgogo.com/images/2020/5/7/1588827051emalh4821_a.jpg',
                        },
                        {
                            num: 107,
                            artist: '王帅',
                            city: '河北',
                            title: '班吉哈的阳光6',
                            size: '29.7*21cm',
                            caizhi: '纸面插画',
                            year: 2020,
                            words: '看似灰色地带的生物却富有积极的生命力量',
                            href: 'http://www.artgogo.com/yishupin/2020-5-7_1588827351342.shtml',
                            img: 'http://www.artgogo.com/images/2020/5/7/1588827249daoglph00_a.jpg',
                        },
                        {
                            num: 108,
                            artist: '王帅',
                            city: '河北',
                            title: '班吉哈的阳光7',
                            size: '29.7*21cm',
                            caizhi: '纸面插画',
                            year: 2020,
                            words: '看似灰色地带的生物却富有积极的生命力量',
                            href: 'http://www.artgogo.com/yishupin/2020-5-7_1588827435998.shtml',
                            img: 'http://www.artgogo.com/images/2020/5/7/1588827385mayhic398_a.jpg',
                        },
                        {
                            num: 109,
                            artist: '王帅',
                            city: '河北',
                            title: '三万线系列纸本作品1',
                            size: '21*29.7cm',
                            caizhi: '纸面插画',
                            year: 2019,
                            words: '疫情来临，我们慌乱不安，也是生命三万天中的灾难，用线条记录这些，愿我们都能够将余下的时间认真，坦然面对',
                            href: 'http://www.artgogo.com/yishupin/2020-5-7_1588834236988.shtml',
                            img: 'http://www.artgogo.com/images/2020/5/7/1588834136dglyhi411_a.jpg',
                        },
                        {
                            num: 110,
                            artist: '王帅',
                            city: '河北',
                            title: '三万线系列纸本作品2',
                            size: '21*29.7cm',
                            caizhi: '纸面插画',
                            year: 2019,
                            words: '疫情来临，我们慌乱不安，也是生命三万天中的灾难，用线条记录这些，愿我们都能够将余下的时间认真，坦然面对',
                            href: 'http://www.artgogo.com/yishupin/2020-5-7_158883465551.shtml',
                            img: 'http://www.artgogo.com/images/2020/5/7/1588834363dolyhics8_a.jpg',
                        },
                        {
                            num: 111,
                            artist: '王帅',
                            city: '河北',
                            title: '三万线系列纸本作品3',
                            size: '21*29.7cm',
                            caizhi: '纸面插画',
                            year: 2019,
                            words: '疫情来临，我们慌乱不安，也是生命三万天中的灾难，用线条记录这些，愿我们都能够将余下的时间认真，坦然面对',
                            href: 'http://www.artgogo.com/yishupin/2020-5-7_1588834815253.shtml',
                            img: 'http://www.artgogo.com/images/2020/5/7/1588834693rapics506_a.jpg',
                        },
                        {
                            num: 112,
                            artist: '王帅',
                            city: '河北',
                            title: '三万线系列纸本作品4',
                            size: '21*29.7cm',
                            caizhi: '纸面插画',
                            year: 2019,
                            words: '疫情来临，我们慌乱不安，也是生命三万天中的灾难，用线条记录这些，愿我们都能够将余下的时间认真，坦然面对',
                            href: 'http://www.artgogo.com/yishupin/2020-5-7_1588835163454.shtml',
                            img: 'http://www.artgogo.com/images/2020/5/7/1588835090rmagyis60_a.jpg',
                        },
                        {
                            num: 113,
                            artist: '王帅',
                            city: '河北',
                            title: '三万线系列纸本作品5',
                            size: '21*29.7cm',
                            caizhi: '纸面插画',
                            year: 2019,
                            words: '疫情来临，我们慌乱不安，也是生命三万天中的灾难，用线条记录这些，愿我们都能够将余下的时间认真，坦然面对',
                            href: 'http://www.artgogo.com/yishupin/2020-5-7_1588835257740.shtml',
                            img: 'http://www.artgogo.com/images/2020/5/7/1588835220deapic375_a.jpg',
                        },
                        {
                            num: 114,
                            artist: '王帅',
                            city: '河北',
                            title: '三万线系列纸本作品6',
                            size: '21*29.7cm',
                            caizhi: '纸面插画',
                            year: 2019,
                            words: '疫情来临，我们慌乱不安，也是生命三万天中的灾难，用线条记录这些，愿我们都能够将余下的时间认真，坦然面对',
                            href: 'http://www.artgogo.com/yishupin/2020-5-7_1588835332319.shtml',
                            img: 'http://www.artgogo.com/images/2020/5/7/1588835275erlphcs52_a.jpg',
                        },
                        {
                            num: 115,
                            artist: '王帅',
                            city: '河北',
                            title: '三万线系列纸本作品7',
                            size: '21*29.7cm',
                            caizhi: '纸面插画',
                            year: 2019,
                            words: '疫情来临，我们慌乱不安，也是生命三万天中的灾难，用线条记录这些，愿我们都能够将余下的时间认真，坦然面对',
                            href: 'http://www.artgogo.com/yishupin/2020-5-7_158883550271.shtml',
                            img: 'http://www.artgogo.com/images/2020/5/7/1588835461deophi423_a.jpg',
                        },
                        {
                            num: 116,
                            artist: '王帅',
                            city: '河北',
                            title: '三万线系列纸本作品8',
                            size: '21*29.7cm',
                            caizhi: '纸面插画',
                            year: 2019,
                            words: '疫情来临，我们慌乱不安，也是生命三万天中的灾难，用线条记录这些，愿我们都能够将余下的时间认真，坦然面对',
                            href: 'http://www.artgogo.com/yishupin/2020-5-7_1588835559778.shtml',
                            img: 'http://www.artgogo.com/images/2020/5/7/1588835527ermohics5_a.jpg',
                        },
                    ],
                    carouselTwo: [
                        {
                            num: 15,
                            artist: '耿晓刚',
                            city: '北京',
                            title: '半日读书半日闲',
                            size: '9*13cm',
                            caizhi: '纸面水彩',
                            year: 2020,
                            words:
                                '隔离期日志-风雪终将过去，春天即将来临！生活状态呈现,艺术刺痛病毒,如何让自己保持一份从容的心面对病毒，在疫情面前如何面对每天的生活疫情考验的不光是身体的免疫力，还有精神的免疫力。在这场没有硝烟的战争让我们更懂得珍惜当下的生活。隔离期不仅仅是对行为的束缚，更是对自我内心的一次梳理与反思，在隔离期内以绘画日志的形式来记录每天的生活，以最真实的写照反映出一天的内心感受，意义在于通过这样的方式让更多的人知道，与其说我们面对疫情的恐惧，不如更好的面对自己，只有保持身心的积极阳光病毒会越来越少，在这样的疫情面前考验的不仅是病毒而是良好的生活状态。',
                            href: 'http://www.artgogo.com/yishupin/2020-2-12_1581505055833.shtml',
                            img: 'http://www.artgogo.com/images/2020/2/12/1581504655rmlpis635_a.jpg',
                        },
                        {
                            num: 16,
                            artist: '耿晓刚',
                            city: '北京',
                            title: '净化器 ',
                            size: '9*13cm',
                            caizhi: '纸面水彩',
                            year: 2020,
                            words:
                                '隔离期日志-风雪终将过去，春天即将来临！,生活状态呈现,艺术刺痛病毒,如何让自己保持一份从容的心面对病毒，,在疫情面前如何面对每天的生活,疫情考验的不光是身体的免疫力，还有精神的免疫力。在这场没有硝烟的战争让我们更懂得珍惜当下的生活。,隔离期不仅仅是对行为的束缚，更是对自我内心的一次梳理与反思，在隔离期内以绘画日志的形式来记录每天的生活，以最真实的写照反映出一天的内心感受，意义在于通过这样的方式让更多的人知道，与其说我们面对疫情的恐惧，不如更好的面对自己，只有保持身心的积极阳光病毒会越来越少，在这样的疫情面前考验的不仅是病毒而是良好的生活状态。',
                            href: 'http://www.artgogo.com/yishupin/2020-2-12_1581505059461.shtml',
                            img: 'http://www.artgogo.com/images/2020/2/12/1581504657maoglyphc_a.jpg',
                        },
                        {
                            num: 17,
                            artist: '耿晓刚',
                            city: '北京',
                            title: '玩偶比熊',
                            size: '9*13cm',
                            caizhi: '纸面水彩',
                            year: 2020,
                            words:
                                '隔离期日志-风雪终将过去，春天即将来临！,生活状态呈现,艺术刺痛病毒,如何让自己保持一份从容的心面对病毒，,在疫情面前如何面对每天的生活,疫情考验的不光是身体的免疫力，还有精神的免疫力。在这场没有硝烟的战争让我们更懂得珍惜当下的生活。,隔离期不仅仅是对行为的束缚，更是对自我内心的一次梳理与反思，在隔离期内以绘画日志的形式来记录每天的生活，以最真实的写照反映出一天的内心感受，意义在于通过这样的方式让更多的人知道，与其说我们面对疫情的恐惧，不如更好的面对自己，只有保持身心的积极阳光病毒会越来越少，在这样的疫情面前考验的不仅是病毒而是良好的生活状态。',
                            href: 'http://www.artgogo.com/yishupin/2020-2-12_158150506575.shtml',
                            img: 'http://www.artgogo.com/images/2020/2/12/1581504659maglhis57_a.jpg',
                        },
                        {
                            num: 18,
                            artist: '耿晓刚',
                            city: '北京',
                            title: '垃圾分类',
                            size: '12*15cm',
                            caizhi: '纸面水彩',
                            year: 2020,
                            words:
                                '隔离期日志-风雪终将过去，春天即将来临！,生活状态呈现,艺术刺痛病毒,如何让自己保持一份从容的心面对病毒，,在疫情面前如何面对每天的生活,疫情考验的不光是身体的免疫力，还有精神的免疫力。在这场没有硝烟的战争让我们更懂得珍惜当下的生活。,隔离期不仅仅是对行为的束缚，更是对自我内心的一次梳理与反思，在隔离期内以绘画日志的形式来记录每天的生活，以最真实的写照反映出一天的内心感受，意义在于通过这样的方式让更多的人知道，与其说我们面对疫情的恐惧，不如更好的面对自己，只有保持身心的积极阳光病毒会越来越少，在这样的疫情面前考验的不仅是病毒而是良好的生活状态。',
                            href: 'http://www.artgogo.com/yishupin/2020-2-12_1581505069286.shtml',
                            img: 'http://www.artgogo.com/images/2020/2/12/1581504662detgpc807_a.jpg',
                        },
                        {
                            num: 19,
                            artist: '耿晓刚',
                            city: '北京',
                            title: '一袋益生菌',
                            size: '19*14cm',
                            caizhi: '纸面水彩',
                            year: 2020,
                            words:
                                '隔离期日志-风雪终将过去，春天即将来临！,生活状态呈现,艺术刺痛病毒,如何让自己保持一份从容的心面对病毒，,在疫情面前如何面对每天的生活,疫情考验的不光是身体的免疫力，还有精神的免疫力。在这场没有硝烟的战争让我们更懂得珍惜当下的生活。,隔离期不仅仅是对行为的束缚，更是对自我内心的一次梳理与反思，在隔离期内以绘画日志的形式来记录每天的生活，以最真实的写照反映出一天的内心感受，意义在于通过这样的方式让更多的人知道，与其说我们面对疫情的恐惧，不如更好的面对自己，只有保持身心的积极阳光病毒会越来越少，在这样的疫情面前考验的不仅是病毒而是良好的生活状态。',
                            href: 'http://www.artgogo.com/yishupin/2020-2-12_1581505074887.shtml',
                            img: 'http://www.artgogo.com/images/2020/2/12/1581504665rmlyic616_a.jpg',
                        },
                        {
                            num: 20,
                            artist: '耿晓刚',
                            city: '北京',
                            title: '油盐酱醋',
                            size: '9*13cm',
                            caizhi: '纸面水彩',
                            year: 2020,
                            words:
                                '隔离期日志-风雪终将过去，春天即将来临！,生活状态呈现,艺术刺痛病毒,如何让自己保持一份从容的心面对病毒，,在疫情面前如何面对每天的生活,疫情考验的不光是身体的免疫力，还有精神的免疫力。在这场没有硝烟的战争让我们更懂得珍惜当下的生活。,隔离期不仅仅是对行为的束缚，更是对自我内心的一次梳理与反思，在隔离期内以绘画日志的形式来记录每天的生活，以最真实的写照反映出一天的内心感受，意义在于通过这样的方式让更多的人知道，与其说我们面对疫情的恐惧，不如更好的面对自己，只有保持身心的积极阳光病毒会越来越少，在这样的疫情面前考验的不仅是病毒而是良好的生活状态。',
                            href: 'http://www.artgogo.com/yishupin/2020-2-12_1581505078995.shtml',
                            img: 'http://www.artgogo.com/images/2020/2/12/1581504667atoglc311_a.jpg',
                        },
                        {
                            num: 21,
                            artist: '耿晓刚',
                            city: '北京',
                            title: '岁月留声',
                            size: '9*13cm',
                            caizhi: '纸面水彩',
                            year: 2020,
                            words:
                                '隔离期日志-风雪终将过去，春天即将来临！,生活状态呈现,艺术刺痛病毒,如何让自己保持一份从容的心面对病毒，,在疫情面前如何面对每天的生活,疫情考验的不光是身体的免疫力，还有精神的免疫力。在这场没有硝烟的战争让我们更懂得珍惜当下的生活。,隔离期不仅仅是对行为的束缚，更是对自我内心的一次梳理与反思，在隔离期内以绘画日志的形式来记录每天的生活，以最真实的写照反映出一天的内心感受，意义在于通过这样的方式让更多的人知道，与其说我们面对疫情的恐惧，不如更好的面对自己，只有保持身心的积极阳光病毒会越来越少，在这样的疫情面前考验的不仅是病毒而是良好的生活状态。',
                            href: 'http://www.artgogo.com/yishupin/2020-2-12_1581505083818.shtml',
                            img: 'http://www.artgogo.com/images/2020/2/12/1581504669oyph27435_a.jpg',
                        },
                        {
                            num: 22,
                            artist: '耿晓刚',
                            city: '北京',
                            title: '窗外冬雪',
                            size: '14*19cm',
                            caizhi: '纸面水彩',
                            year: 2020,
                            words:
                                '隔离期日志-风雪终将过去，春天即将来临！,生活状态呈现,艺术刺痛病毒,如何让自己保持一份从容的心面对病毒，,在疫情面前如何面对每天的生活,疫情考验的不光是身体的免疫力，还有精神的免疫力。在这场没有硝烟的战争让我们更懂得珍惜当下的生活。,隔离期不仅仅是对行为的束缚，更是对自我内心的一次梳理与反思，在隔离期内以绘画日志的形式来记录每天的生活，以最真实的写照反映出一天的内心感受，意义在于通过这样的方式让更多的人知道，与其说我们面对疫情的恐惧，不如更好的面对自己，只有保持身心的积极阳光病毒会越来越少，在这样的疫情面前考验的不仅是病毒而是良好的生活状态。',
                            href: 'http://www.artgogo.com/yishupin/2020-2-12_1581505087948.shtml',
                            img: 'http://www.artgogo.com/images/2020/2/12/1581504671ahics4386_a.jpg',
                        },
                        {
                            num: 23,
                            artist: '耿晓刚',
                            city: '北京',
                            title: '断舍离',
                            size: '9*13cm',
                            caizhi: '纸面水彩',
                            year: 2020,
                            words:
                                '隔离期日志-风雪终将过去，春天即将来临！,生活状态呈现,艺术刺痛病毒,如何让自己保持一份从容的心面对病毒，,在疫情面前如何面对每天的生活,疫情考验的不光是身体的免疫力，还有精神的免疫力。在这场没有硝烟的战争让我们更懂得珍惜当下的生活。,隔离期不仅仅是对行为的束缚，更是对自我内心的一次梳理与反思，在隔离期内以绘画日志的形式来记录每天的生活，以最真实的写照反映出一天的内心感受，意义在于通过这样的方式让更多的人知道，与其说我们面对疫情的恐惧，不如更好的面对自己，只有保持身心的积极阳光病毒会越来越少，在这样的疫情面前考验的不仅是病毒而是良好的生活状态。',
                            href: 'http://www.artgogo.com/yishupin/2020-2-12_1581505092300.shtml',
                            img: 'http://www.artgogo.com/images/2020/2/12/1581504673dmogyhi80_a.jpg',
                        },
                        {
                            num: 24,
                            artist: '耿晓刚',
                            city: '北京',
                            title: '钢琴',
                            size: '9*13cm',
                            caizhi: '纸面水彩',
                            year: 2020,
                            words:
                                '隔离期日志-风雪终将过去，春天即将来临！,生活状态呈现,艺术刺痛病毒,如何让自己保持一份从容的心面对病毒，,在疫情面前如何面对每天的生活,疫情考验的不光是身体的免疫力，还有精神的免疫力。在这场没有硝烟的战争让我们更懂得珍惜当下的生活。,隔离期不仅仅是对行为的束缚，更是对自我内心的一次梳理与反思，在隔离期内以绘画日志的形式来记录每天的生活，以最真实的写照反映出一天的内心感受，意义在于通过这样的方式让更多的人知道，与其说我们面对疫情的恐惧，不如更好的面对自己，只有保持身心的积极阳光病毒会越来越少，在这样的疫情面前考验的不仅是病毒而是良好的生活状态。',
                            href: 'http://www.artgogo.com/yishupin/2020-2-12_1581505096303.shtml',
                            img: 'http://www.artgogo.com/images/2020/2/12/1581504675deaogyh46_a.jpg',
                        },
                        {
                            num: 25,
                            artist: '耿晓刚',
                            city: '北京',
                            title: '此物最磨牙',
                            size: '9*13cm',
                            caizhi: '纸面水彩',
                            year: 2020,
                            words:
                                '隔离期日志-风雪终将过去，春天即将来临！,生活状态呈现,艺术刺痛病毒,如何让自己保持一份从容的心面对病毒，,在疫情面前如何面对每天的生活,疫情考验的不光是身体的免疫力，还有精神的免疫力。在这场没有硝烟的战争让我们更懂得珍惜当下的生活。,隔离期不仅仅是对行为的束缚，更是对自我内心的一次梳理与反思，在隔离期内以绘画日志的形式来记录每天的生活，以最真实的写照反映出一天的内心感受，意义在于通过这样的方式让更多的人知道，与其说我们面对疫情的恐惧，不如更好的面对自己，只有保持身心的积极阳光病毒会越来越少，在这样的疫情面前考验的不仅是病毒而是良好的生活状态。',
                            href: 'http://www.artgogo.com/yishupin/2020-2-12_1581506332627.shtml',
                            img: 'http://www.artgogo.com/images/2020/2/12/1581505120erogc3125_a.jpg',
                        },
                        {
                            num: 26,
                            artist: '耿晓刚',
                            city: '北京',
                            title: '消毒成本有点高',
                            size: '9*13cm',
                            caizhi: '纸面水彩',
                            year: 2020,
                            words:
                                '隔离期日志-风雪终将过去，春天即将来临！,生活状态呈现,艺术刺痛病毒,如何让自己保持一份从容的心面对病毒，,在疫情面前如何面对每天的生活,疫情考验的不光是身体的免疫力，还有精神的免疫力。在这场没有硝烟的战争让我们更懂得珍惜当下的生活。,隔离期不仅仅是对行为的束缚，更是对自我内心的一次梳理与反思，在隔离期内以绘画日志的形式来记录每天的生活，以最真实的写照反映出一天的内心感受，意义在于通过这样的方式让更多的人知道，与其说我们面对疫情的恐惧，不如更好的面对自己，只有保持身心的积极阳光病毒会越来越少，在这样的疫情面前考验的不仅是病毒而是良好的生活状态。',
                            href: 'http://www.artgogo.com/yishupin/2020-2-12_1581506339644.shtml',
                            img: 'http://www.artgogo.com/images/2020/2/12/1581505122rtolphi94_a.jpg',
                        },
                        {
                            num: 27,
                            artist: '耿晓刚',
                            city: '北京',
                            title: '生抽、老抽、米醋',
                            size: '9*13cm',
                            caizhi: '纸面水彩',
                            year: 2020,
                            words:
                                '隔离期日志-风雪终将过去，春天即将来临！,生活状态呈现,艺术刺痛病毒,如何让自己保持一份从容的心面对病毒，,在疫情面前如何面对每天的生活,疫情考验的不光是身体的免疫力，还有精神的免疫力。在这场没有硝烟的战争让我们更懂得珍惜当下的生活。,隔离期不仅仅是对行为的束缚，更是对自我内心的一次梳理与反思，在隔离期内以绘画日志的形式来记录每天的生活，以最真实的写照反映出一天的内心感受，意义在于通过这样的方式让更多的人知道，与其说我们面对疫情的恐惧，不如更好的面对自己，只有保持身心的积极阳光病毒会越来越少，在这样的疫情面前考验的不仅是病毒而是良好的生活状态。',
                            href: 'http://www.artgogo.com/yishupin/2020-2-12_1581506346624.shtml',
                            img: 'http://www.artgogo.com/images/2020/2/12/1581505125eraglypi0_a.jpg',
                        },
                        {
                            num: 28,
                            artist: '耿晓刚',
                            city: '北京',
                            title: '安贞楼下',
                            size: '9*13cm',
                            caizhi: '纸面水彩',
                            year: 2020,
                            words:
                                '隔离期日志-风雪终将过去，春天即将来临！,生活状态呈现,艺术刺痛病毒,如何让自己保持一份从容的心面对病毒，,在疫情面前如何面对每天的生活,疫情考验的不光是身体的免疫力，还有精神的免疫力。在这场没有硝烟的战争让我们更懂得珍惜当下的生活。,隔离期不仅仅是对行为的束缚，更是对自我内心的一次梳理与反思，在隔离期内以绘画日志的形式来记录每天的生活，以最真实的写照反映出一天的内心感受，意义在于通过这样的方式让更多的人知道，与其说我们面对疫情的恐惧，不如更好的面对自己，只有保持身心的积极阳光病毒会越来越少，在这样的疫情面前考验的不仅是病毒而是良好的生活状态。',
                            href: 'http://www.artgogo.com/yishupin/2020-2-12_1581506351906.shtml',
                            img: 'http://www.artgogo.com/images/2020/2/12/1581505127rtoyic592_a.jpg',
                        },
                        {
                            num: 29,
                            artist: '耿晓刚',
                            city: '北京',
                            title: '出口',
                            size: '9*13cm',
                            caizhi: '纸面水彩',
                            year: 2020,
                            words:
                                '隔离期日志-风雪终将过去，春天即将来临！,生活状态呈现,艺术刺痛病毒,如何让自己保持一份从容的心面对病毒，,在疫情面前如何面对每天的生活,疫情考验的不光是身体的免疫力，还有精神的免疫力。在这场没有硝烟的战争让我们更懂得珍惜当下的生活。,隔离期不仅仅是对行为的束缚，更是对自我内心的一次梳理与反思，在隔离期内以绘画日志的形式来记录每天的生活，以最真实的写照反映出一天的内心感受，意义在于通过这样的方式让更多的人知道，与其说我们面对疫情的恐惧，不如更好的面对自己，只有保持身心的积极阳光病毒会越来越少，在这样的疫情面前考验的不仅是病毒而是良好的生活状态。',
                            href: 'http://www.artgogo.com/yishupin/2020-2-12_1581506356321.shtml',
                            img: 'http://www.artgogo.com/images/2020/2/12/1581505129rglyhi966_a.jpg',
                        },
                        {
                            num: 30,
                            artist: '耿晓刚',
                            city: '北京',
                            title: '点燃希望',
                            size: '9*13cm',
                            caizhi: '纸面水彩',
                            year: 2020,
                            words:
                                '隔离期日志-风雪终将过去，春天即将来临！,生活状态呈现,艺术刺痛病毒,如何让自己保持一份从容的心面对病毒，,在疫情面前如何面对每天的生活,疫情考验的不光是身体的免疫力，还有精神的免疫力。在这场没有硝烟的战争让我们更懂得珍惜当下的生活。,隔离期不仅仅是对行为的束缚，更是对自我内心的一次梳理与反思，在隔离期内以绘画日志的形式来记录每天的生活，以最真实的写照反映出一天的内心感受，意义在于通过这样的方式让更多的人知道，与其说我们面对疫情的恐惧，不如更好的面对自己，只有保持身心的积极阳光病毒会越来越少，在这样的疫情面前考验的不仅是病毒而是良好的生活状态。',
                            href: 'http://www.artgogo.com/yishupin/2020-2-12_1581506362784.shtml',
                            img: 'http://www.artgogo.com/images/2020/2/12/1581505131demtoli88_a.jpg',
                        },
                        {
                            num: 31,
                            artist: '耿晓刚',
                            city: '北京',
                            title: '爱心物资',
                            size: '9*13cm',
                            caizhi: '纸面水彩',
                            year: 2020,
                            words:
                                '隔离期日志-风雪终将过去，春天即将来临！,生活状态呈现,艺术刺痛病毒,如何让自己保持一份从容的心面对病毒，,在疫情面前如何面对每天的生活,疫情考验的不光是身体的免疫力，还有精神的免疫力。在这场没有硝烟的战争让我们更懂得珍惜当下的生活。,隔离期不仅仅是对行为的束缚，更是对自我内心的一次梳理与反思，在隔离期内以绘画日志的形式来记录每天的生活，以最真实的写照反映出一天的内心感受，意义在于通过这样的方式让更多的人知道，与其说我们面对疫情的恐惧，不如更好的面对自己，只有保持身心的积极阳光病毒会越来越少，在这样的疫情面前考验的不仅是病毒而是良好的生活状态。',
                            href: 'http://www.artgogo.com/yishupin/2020-2-12_158150636759.shtml',
                            img: 'http://www.artgogo.com/images/2020/2/12/1581505134rtolhic87_a.jpg',
                        },
                        {
                            num: 32,
                            artist: '耿晓刚',
                            city: '北京',
                            title: '四季平安',
                            size: '12*15cm',
                            caizhi: '纸面水彩',
                            year: 2020,
                            words:
                                '隔离期日志-风雪终将过去，春天即将来临！,生活状态呈现,艺术刺痛病毒,如何让自己保持一份从容的心面对病毒，,在疫情面前如何面对每天的生活,疫情考验的不光是身体的免疫力，还有精神的免疫力。在这场没有硝烟的战争让我们更懂得珍惜当下的生活。,隔离期不仅仅是对行为的束缚，更是对自我内心的一次梳理与反思，在隔离期内以绘画日志的形式来记录每天的生活，以最真实的写照反映出一天的内心感受，意义在于通过这样的方式让更多的人知道，与其说我们面对疫情的恐惧，不如更好的面对自己，只有保持身心的积极阳光病毒会越来越少，在这样的疫情面前考验的不仅是病毒而是良好的生活状态。',
                            href: 'http://www.artgogo.com/yishupin/2020-2-12_1581506731383.shtml',
                            img: 'http://www.artgogo.com/images/2020/2/12/1581506670ratohic32_a.jpg',
                        },
                        {
                            num: 33,
                            artist: '耿晓刚',
                            city: '北京',
                            title: '少上网多发呆',
                            size: '9*13cm',
                            caizhi: '纸面水彩',
                            year: 2020,
                            words:
                                '隔离期日志-风雪终将过去，春天即将来临！,生活状态呈现,艺术刺痛病毒,如何让自己保持一份从容的心面对病毒，,在疫情面前如何面对每天的生活,疫情考验的不光是身体的免疫力，还有精神的免疫力。在这场没有硝烟的战争让我们更懂得珍惜当下的生活。,隔离期不仅仅是对行为的束缚，更是对自我内心的一次梳理与反思，在隔离期内以绘画日志的形式来记录每天的生活，以最真实的写照反映出一天的内心感受，意义在于通过这样的方式让更多的人知道，与其说我们面对疫情的恐惧，不如更好的面对自己，只有保持身心的积极阳光病毒会越来越少，在这样的疫情面前考验的不仅是病毒而是良好的生活状态。',
                            href: 'http://www.artgogo.com/yishupin/2020-2-12_1581506372298.shtml',
                            img: 'http://www.artgogo.com/images/2020/2/12/1581505136dogypcs45_a.jpg',
                        },
                        {
                            num: 34,
                            artist: '耿晓刚',
                            city: '北京',
                            title: '安心',
                            size: '14*19cm',
                            caizhi: '纸面水彩',
                            year: 2020,
                            words:
                                '隔离期日志-风雪终将过去，春天即将来临！,生活状态呈现,艺术刺痛病毒,如何让自己保持一份从容的心面对病毒，,在疫情面前如何面对每天的生活,疫情考验的不光是身体的免疫力，还有精神的免疫力。在这场没有硝烟的战争让我们更懂得珍惜当下的生活。,隔离期不仅仅是对行为的束缚，更是对自我内心的一次梳理与反思，在隔离期内以绘画日志的形式来记录每天的生活，以最真实的写照反映出一天的内心感受，意义在于通过这样的方式让更多的人知道，与其说我们面对疫情的恐惧，不如更好的面对自己，只有保持身心的积极阳光病毒会越来越少，在这样的疫情面前考验的不仅是病毒而是良好的生活状态。',
                            href: 'http://www.artgogo.com/yishupin/2020-2-12_1581506377684.shtml',
                            img: 'http://www.artgogo.com/images/2020/2/12/1581505139moghis585_a.jpg',
                        },
                        {
                            num: 35,
                            artist: '耿晓刚',
                            city: '北京',
                            title: '隔离',
                            size: '9*13cm',
                            caizhi: '纸面水彩',
                            year: 2020,
                            words:
                                '隔离期日志-风雪终将过去，春天即将来临！,生活状态呈现,艺术刺痛病毒,如何让自己保持一份从容的心面对病毒，,在疫情面前如何面对每天的生活,疫情考验的不光是身体的免疫力，还有精神的免疫力。在这场没有硝烟的战争让我们更懂得珍惜当下的生活。,隔离期不仅仅是对行为的束缚，更是对自我内心的一次梳理与反思，在隔离期内以绘画日志的形式来记录每天的生活，以最真实的写照反映出一天的内心感受，意义在于通过这样的方式让更多的人知道，与其说我们面对疫情的恐惧，不如更好的面对自己，只有保持身心的积极阳光病毒会越来越少，在这样的疫情面前考验的不仅是病毒而是良好的生活状态。',
                            href: 'http://www.artgogo.com/yishupin/2020-2-12_1581507434446.shtml',
                            img: 'http://www.artgogo.com/images/2020/2/12/1581507247rmatgphc5_a.jpg',
                        },
                        {
                            num: 36,
                            artist: '耿晓刚',
                            city: '北京',
                            title: '开工延期',
                            size: '9*13cm',
                            caizhi: '纸面水彩',
                            year: 2020,
                            words:
                                '隔离期日志-风雪终将过去，春天即将来临！,生活状态呈现,艺术刺痛病毒,如何让自己保持一份从容的心面对病毒，,在疫情面前如何面对每天的生活,疫情考验的不光是身体的免疫力，还有精神的免疫力。在这场没有硝烟的战争让我们更懂得珍惜当下的生活。,隔离期不仅仅是对行为的束缚，更是对自我内心的一次梳理与反思，在隔离期内以绘画日志的形式来记录每天的生活，以最真实的写照反映出一天的内心感受，意义在于通过这样的方式让更多的人知道，与其说我们面对疫情的恐惧，不如更好的面对自己，只有保持身心的积极阳光病毒会越来越少，在这样的疫情面前考验的不仅是病毒而是良好的生活状态。',
                            href: 'http://www.artgogo.com/yishupin/2020-2-12_1581507163915.shtml',
                            img: 'http://www.artgogo.com/images/2020/2/12/1581506772tglics248_a.jpg',
                        },
                        {
                            num: 37,
                            artist: '耿晓刚',
                            city: '北京',
                            title: '庚子春雪',
                            size: '9*13cm',
                            caizhi: '纸面水彩',
                            year: 2020,
                            words:
                                '隔离期日志-风雪终将过去，春天即将来临！,生活状态呈现,艺术刺痛病毒,如何让自己保持一份从容的心面对病毒，,在疫情面前如何面对每天的生活,疫情考验的不光是身体的免疫力，还有精神的免疫力。在这场没有硝烟的战争让我们更懂得珍惜当下的生活。,隔离期不仅仅是对行为的束缚，更是对自我内心的一次梳理与反思，在隔离期内以绘画日志的形式来记录每天的生活，以最真实的写照反映出一天的内心感受，意义在于通过这样的方式让更多的人知道，与其说我们面对疫情的恐惧，不如更好的面对自己，只有保持身心的积极阳光病毒会越来越少，在这样的疫情面前考验的不仅是病毒而是良好的生活状态。',
                            href: 'http://www.artgogo.com/yishupin/2020-2-12_1581507167532.shtml',
                            img: 'http://www.artgogo.com/images/2020/2/12/1581506775eralphi50_a.jpg',
                        },
                        {
                            num: 38,
                            artist: '耿晓刚',
                            city: '北京',
                            title: '华灯',
                            size: '9*13cm',
                            caizhi: '纸面水彩',
                            year: 2020,
                            words:
                                '隔离期日志-风雪终将过去，春天即将来临！,生活状态呈现,艺术刺痛病毒,如何让自己保持一份从容的心面对病毒，,在疫情面前如何面对每天的生活,疫情考验的不光是身体的免疫力，还有精神的免疫力。在这场没有硝烟的战争让我们更懂得珍惜当下的生活。,隔离期不仅仅是对行为的束缚，更是对自我内心的一次梳理与反思，在隔离期内以绘画日志的形式来记录每天的生活，以最真实的写照反映出一天的内心感受，意义在于通过这样的方式让更多的人知道，与其说我们面对疫情的恐惧，不如更好的面对自己，只有保持身心的积极阳光病毒会越来越少，在这样的疫情面前考验的不仅是病毒而是良好的生活状态。',
                            href: 'http://www.artgogo.com/yishupin/2020-2-12_1581507171543.shtml',
                            img: 'http://www.artgogo.com/images/2020/2/12/1581506777derys2327_a.jpg',
                        },
                        {
                            num: 39,
                            artist: '耿晓刚',
                            city: '北京',
                            title: '上网课',
                            size: '9*13cm',
                            caizhi: '纸面水彩',
                            year: 2020,
                            words:
                                '隔离期日志-风雪终将过去，春天即将来临！,生活状态呈现,艺术刺痛病毒,如何让自己保持一份从容的心面对病毒，,在疫情面前如何面对每天的生活,疫情考验的不光是身体的免疫力，还有精神的免疫力。在这场没有硝烟的战争让我们更懂得珍惜当下的生活。,隔离期不仅仅是对行为的束缚，更是对自我内心的一次梳理与反思，在隔离期内以绘画日志的形式来记录每天的生活，以最真实的写照反映出一天的内心感受，意义在于通过这样的方式让更多的人知道，与其说我们面对疫情的恐惧，不如更好的面对自己，只有保持身心的积极阳光病毒会越来越少，在这样的疫情面前考验的不仅是病毒而是良好的生活状态。',
                            href: 'http://www.artgogo.com/yishupin/2020-2-12_1581507176997.shtml',
                            img: 'http://www.artgogo.com/images/2020/2/12/1581506779eralcs671_a.jpg',
                        },
                        {
                            num: 40,
                            artist: '耿晓刚',
                            city: '北京',
                            title: '吃茶',
                            size: '9*13cm',
                            caizhi: '纸面水彩',
                            year: 2020,
                            words:
                                '隔离期日志-风雪终将过去，春天即将来临！,生活状态呈现,艺术刺痛病毒,如何让自己保持一份从容的心面对病毒，,在疫情面前如何面对每天的生活,疫情考验的不光是身体的免疫力，还有精神的免疫力。在这场没有硝烟的战争让我们更懂得珍惜当下的生活。,隔离期不仅仅是对行为的束缚，更是对自我内心的一次梳理与反思，在隔离期内以绘画日志的形式来记录每天的生活，以最真实的写照反映出一天的内心感受，意义在于通过这样的方式让更多的人知道，与其说我们面对疫情的恐惧，不如更好的面对自己，只有保持身心的积极阳光病毒会越来越少，在这样的疫情面前考验的不仅是病毒而是良好的生活状态。',
                            href: 'http://www.artgogo.com/yishupin/2020-2-12_1581507181118.shtml',
                            img: 'http://www.artgogo.com/images/2020/2/12/1581506782deoglhc14_a.jpg',
                        },
                        {
                            num: 41,
                            artist: '耿晓刚',
                            city: '北京',
                            title: '勤洗手',
                            size: '9*13cm',
                            caizhi: '纸面水彩',
                            year: 2020,
                            words:
                                '隔离期日志-风雪终将过去，春天即将来临！,生活状态呈现,艺术刺痛病毒,如何让自己保持一份从容的心面对病毒，,在疫情面前如何面对每天的生活,疫情考验的不光是身体的免疫力，还有精神的免疫力。在这场没有硝烟的战争让我们更懂得珍惜当下的生活。,隔离期不仅仅是对行为的束缚，更是对自我内心的一次梳理与反思，在隔离期内以绘画日志的形式来记录每天的生活，以最真实的写照反映出一天的内心感受，意义在于通过这样的方式让更多的人知道，与其说我们面对疫情的恐惧，不如更好的面对自己，只有保持身心的积极阳光病毒会越来越少，在这样的疫情面前考验的不仅是病毒而是良好的生活状态。',
                            href: 'http://www.artgogo.com/yishupin/2020-2-12_1581507186444.shtml',
                            img: 'http://www.artgogo.com/images/2020/2/12/1581506784demaocs57_a.jpg',
                        },
                        {
                            num: 42,
                            artist: '耿晓刚',
                            city: '北京',
                            title: '独酌',
                            size: '9*13cm',
                            caizhi: '纸面水彩',
                            year: 2020,
                            words:
                                '隔离期日志-风雪终将过去，春天即将来临！,生活状态呈现,艺术刺痛病毒,如何让自己保持一份从容的心面对病毒，,在疫情面前如何面对每天的生活,疫情考验的不光是身体的免疫力，还有精神的免疫力。在这场没有硝烟的战争让我们更懂得珍惜当下的生活。,隔离期不仅仅是对行为的束缚，更是对自我内心的一次梳理与反思，在隔离期内以绘画日志的形式来记录每天的生活，以最真实的写照反映出一天的内心感受，意义在于通过这样的方式让更多的人知道，与其说我们面对疫情的恐惧，不如更好的面对自己，只有保持身心的积极阳光病毒会越来越少，在这样的疫情面前考验的不仅是病毒而是良好的生活状态。',
                            href: 'http://www.artgogo.com/yishupin/2020-2-12_1581507190834.shtml',
                            img: 'http://www.artgogo.com/images/2020/2/12/1581506787toglpis12_a.jpg',
                        },
                        {
                            num: 43,
                            artist: '耿晓刚',
                            city: '北京',
                            title: '一炷香',
                            size: '9*13cm',
                            caizhi: '纸面水彩',
                            year: 2020,
                            words:
                                '隔离期日志-风雪终将过去，春天即将来临！,生活状态呈现,艺术刺痛病毒,如何让自己保持一份从容的心面对病毒，,在疫情面前如何面对每天的生活,疫情考验的不光是身体的免疫力，还有精神的免疫力。在这场没有硝烟的战争让我们更懂得珍惜当下的生活。,隔离期不仅仅是对行为的束缚，更是对自我内心的一次梳理与反思，在隔离期内以绘画日志的形式来记录每天的生活，以最真实的写照反映出一天的内心感受，意义在于通过这样的方式让更多的人知道，与其说我们面对疫情的恐惧，不如更好的面对自己，只有保持身心的积极阳光病毒会越来越少，在这样的疫情面前考验的不仅是病毒而是良好的生活状态。',
                            href: 'http://www.artgogo.com/yishupin/2020-2-12_158150719511.shtml',
                            img: 'http://www.artgogo.com/images/2020/2/12/1581506788rmolpics3_a.jpg',
                        },
                        {
                            num: 44,
                            artist: '耿晓刚',
                            city: '北京',
                            title: '伊狗狗',
                            size: '9*13cm',
                            caizhi: '纸面水彩',
                            year: 2020,
                            words:
                                '隔离期日志-风雪终将过去，春天即将来临！,生活状态呈现,艺术刺痛病毒,如何让自己保持一份从容的心面对病毒，,在疫情面前如何面对每天的生活,疫情考验的不光是身体的免疫力，还有精神的免疫力。在这场没有硝烟的战争让我们更懂得珍惜当下的生活。,隔离期不仅仅是对行为的束缚，更是对自我内心的一次梳理与反思，在隔离期内以绘画日志的形式来记录每天的生活，以最真实的写照反映出一天的内心感受，意义在于通过这样的方式让更多的人知道，与其说我们面对疫情的恐惧，不如更好的面对自己，只有保持身心的积极阳光病毒会越来越少，在这样的疫情面前考验的不仅是病毒而是良好的生活状态。',
                            href: 'http://www.artgogo.com/yishupin/2020-2-12_1581507440578.shtml',
                            img: 'http://www.artgogo.com/images/2020/2/12/1581507249emgyps068_a.jpg',
                        },
                        {
                            num: 45,
                            artist: '耿晓刚',
                            city: '北京',
                            title: '补充能量组',
                            size: '9*13cm',
                            caizhi: '纸面水彩',
                            year: 2020,
                            words:
                                '隔离期日志-风雪终将过去，春天即将来临！,生活状态呈现,艺术刺痛病毒,如何让自己保持一份从容的心面对病毒，,在疫情面前如何面对每天的生活,疫情考验的不光是身体的免疫力，还有精神的免疫力。在这场没有硝烟的战争让我们更懂得珍惜当下的生活。,隔离期不仅仅是对行为的束缚，更是对自我内心的一次梳理与反思，在隔离期内以绘画日志的形式来记录每天的生活，以最真实的写照反映出一天的内心感受，意义在于通过这样的方式让更多的人知道，与其说我们面对疫情的恐惧，不如更好的面对自己，只有保持身心的积极阳光病毒会越来越少，在这样的疫情面前考验的不仅是病毒而是良好的生活状态。',
                            href: 'http://www.artgogo.com/yishupin/2020-2-12_1581507865604.shtml',
                            img: 'http://www.artgogo.com/images/2020/2/12/1581507593mtli94796_a.jpg',
                        },
                        {
                            num: 46,
                            artist: '耿晓刚',
                            city: '北京',
                            title: '陨落',
                            size: '9*13cm',
                            caizhi: '纸面水彩',
                            year: 2020,
                            words:
                                '隔离期日志-风雪终将过去，春天即将来临！,生活状态呈现,艺术刺痛病毒,如何让自己保持一份从容的心面对病毒，,在疫情面前如何面对每天的生活,疫情考验的不光是身体的免疫力，还有精神的免疫力。在这场没有硝烟的战争让我们更懂得珍惜当下的生活。,隔离期不仅仅是对行为的束缚，更是对自我内心的一次梳理与反思，在隔离期内以绘画日志的形式来记录每天的生活，以最真实的写照反映出一天的内心感受，意义在于通过这样的方式让更多的人知道，与其说我们面对疫情的恐惧，不如更好的面对自己，只有保持身心的积极阳光病毒会越来越少，在这样的疫情面前考验的不仅是病毒而是良好的生活状态。',
                            href: 'http://www.artgogo.com/yishupin/2020-2-12_1581507870340.shtml',
                            img: 'http://www.artgogo.com/images/2020/2/12/1581507595aphics985_a.jpg',
                        },
                        {
                            num: 47,
                            artist: '耿晓刚',
                            city: '北京',
                            title: '对视',
                            size: '9*13cm',
                            caizhi: '纸面水彩',
                            year: 2020,
                            words:
                                '隔离期日志-风雪终将过去，春天即将来临！,生活状态呈现,艺术刺痛病毒,如何让自己保持一份从容的心面对病毒，,在疫情面前如何面对每天的生活,疫情考验的不光是身体的免疫力，还有精神的免疫力。在这场没有硝烟的战争让我们更懂得珍惜当下的生活。,隔离期不仅仅是对行为的束缚，更是对自我内心的一次梳理与反思，在隔离期内以绘画日志的形式来记录每天的生活，以最真实的写照反映出一天的内心感受，意义在于通过这样的方式让更多的人知道，与其说我们面对疫情的恐惧，不如更好的面对自己，只有保持身心的积极阳光病毒会越来越少，在这样的疫情面前考验的不仅是病毒而是良好的生活状态。',
                            href: 'http://www.artgogo.com/yishupin/2020-2-12_1581507874265.shtml',
                            img: 'http://www.artgogo.com/images/2020/2/12/1581507597daoyphi33_a.jpg',
                        },
                        {
                            num: 48,
                            artist: '耿晓刚',
                            city: '北京',
                            title: '最美医护',
                            size: '9*13cm',
                            caizhi: '纸面水彩',
                            year: 2020,
                            words:
                                '隔离期日志-风雪终将过去，春天即将来临！,生活状态呈现,艺术刺痛病毒,如何让自己保持一份从容的心面对病毒，,在疫情面前如何面对每天的生活,疫情考验的不光是身体的免疫力，还有精神的免疫力。在这场没有硝烟的战争让我们更懂得珍惜当下的生活。,隔离期不仅仅是对行为的束缚，更是对自我内心的一次梳理与反思，在隔离期内以绘画日志的形式来记录每天的生活，以最真实的写照反映出一天的内心感受，意义在于通过这样的方式让更多的人知道，与其说我们面对疫情的恐惧，不如更好的面对自己，只有保持身心的积极阳光病毒会越来越少，在这样的疫情面前考验的不仅是病毒而是良好的生活状态。',
                            href: 'http://www.artgogo.com/yishupin/2020-2-12_1581507879396.shtml',
                            img: 'http://www.artgogo.com/images/2020/2/12/1581507599rtoyis540_a.jpg',
                        },
                        {
                            num: 49,
                            artist: '耿晓刚',
                            city: '北京',
                            title: '众志成城',
                            size: '9*13cm',
                            caizhi: '纸面水彩',
                            year: 2020,
                            words:
                                '隔离期日志-风雪终将过去，春天即将来临！,生活状态呈现,艺术刺痛病毒,如何让自己保持一份从容的心面对病毒，,在疫情面前如何面对每天的生活,疫情考验的不光是身体的免疫力，还有精神的免疫力。在这场没有硝烟的战争让我们更懂得珍惜当下的生活。,隔离期不仅仅是对行为的束缚，更是对自我内心的一次梳理与反思，在隔离期内以绘画日志的形式来记录每天的生活，以最真实的写照反映出一天的内心感受，意义在于通过这样的方式让更多的人知道，与其说我们面对疫情的恐惧，不如更好的面对自己，只有保持身心的积极阳光病毒会越来越少，在这样的疫情面前考验的不仅是病毒而是良好的生活状态。',
                            href: 'http://www.artgogo.com/yishupin/2020-2-12_1581507883131.shtml',
                            img: 'http://www.artgogo.com/images/2020/2/12/1581507600ratphcs41_a.jpg',
                        },
                        {
                            num: 50,
                            artist: '耿晓刚',
                            city: '北京',
                            title: '冬天终过去，春天将来临！',
                            size: '15*12cm',
                            caizhi: '纸面水彩',
                            year: 2020,
                            words:
                                '隔离期日志-风雪终将过去，春天即将来临！,生活状态呈现,艺术刺痛病毒,如何让自己保持一份从容的心面对病毒，,在疫情面前如何面对每天的生活,疫情考验的不光是身体的免疫力，还有精神的免疫力。在这场没有硝烟的战争让我们更懂得珍惜当下的生活。,隔离期不仅仅是对行为的束缚，更是对自我内心的一次梳理与反思，在隔离期内以绘画日志的形式来记录每天的生活，以最真实的写照反映出一天的内心感受，意义在于通过这样的方式让更多的人知道，与其说我们面对疫情的恐惧，不如更好的面对自己，只有保持身心的积极阳光病毒会越来越少，在这样的疫情面前考验的不仅是病毒而是良好的生活状态。',
                            href: 'http://www.artgogo.com/yishupin/2020-2-12_1581507888653.shtml',
                            img: 'http://www.artgogo.com/images/2020/2/12/1581507603eratolp48_a.jpg',
                        },
                    ],
                },
                {
                    backgroundImg: '13.jpg',
                    mapVisible: false,
                    microphone: false,
                    mapIcon: true,
                    MaskShow: true,
                    classNameOne: 'searchPos10',
                    classNameTwo: 'searchPos10-1',
                    hasHandler: true,
                    hasAudio: true,
                    peter: {
                        num: 78,
                        artist: 'Peter Riezebos',
                        city: '荷兰',
                        title: 'Black & White Color Complex 黑白情结',
                        size: '200*200cm',
                        caizhi: '布面综合材料',
                        year: 2016,
                        href: 'http://www.artgogo.com/yishupin/2016-1-15_1452830309386.shtml',
                        img: 'http://www.artgogo.com/yishupin/images/2017/5/19/20175191495187623167_376_a.jpg',
                        words:
                            'Perception - in art and as a psychological and philosophical construct - has many layers. From the surface structures to many underlying elements that can be discovered. Such is life. Sometimes it presents obstacles on face value which also presents opportunities that urge a deeper thinking and facilitate an understanding of humanity and nature. Art can helps us overcome many obstacles in life.感知：在艺术中以及作为一种心理学和哲学里的建构，感知都具有许多层次。可以从表面结构一直深入到底层发现很多元素。 这就是生活。 有时，它在表面上布满荆棘，却也提供了促使人们进行更深入的思考并对人性与大自然更深入理解的机会。艺术可以帮助我们克服生活中的许多障碍。这幅画也许黑白的感觉占了主导地位，但明亮的色彩隐隐约约地穿过了它。',
                        audioCont: ['http://www.artgogo.com/online-exhibition/haipai-music/Peter_1_1.MP3'],
                        lyric: [
                            {
                                time: '01',
                                words: "Hi everyone, I'm Peter Riezebos<br/>哈咯 大家好 我是彼得·莱兹伯斯",
                            },
                            {
                                time: '04',
                                words: ' I hope that my painting "Black & White Color Complex" <br/>希望我的“黑白情结”',
                            },
                            {
                                time: '07',
                                words: 'reminds us to look beyond the surface<br/>能提醒我们看到比表面更深层的东西',
                            },
                            {
                                time: '11',
                                words: 'and encourages us to overcome obstacles in life<br/>并且鼓励我们战胜生命中的困难',
                            },
                        ],
                    },

                    yangdifei: {
                        num: 4,
                        artist: '杨狄霏',
                        city: '上海',
                        title: '口罩',
                        size: '180*180cm',
                        caizhi: '布面油画',
                        year: 2020,
                        href: 'http://www.artgogo.com/yishupin/2020-3-1_1583067736284.shtml',
                        img: 'http://www.artgogo.com/images/2020/3/1/1583067688matglhic7_a.jpg',
                        words: '希望大家保护野生，不要猎杀、捕食野生动物。',
                        audioCont: ['http://www.artgogo.com/online-exhibition/haipai-music/yangdifei.mp3'],
                        lyric: [
                            {
                                time: '01',
                                words: '大家好 我是杨狄霏<br/>口罩这幅作品',
                            },
                            {
                                time: '03',
                                words: '为的是希望大家共同抵制<br/>捕杀与买卖野生动物的行为',
                            },

                            {
                                time: '07',
                                words: '保护它们 <br/>也保护我们自己',
                            },
                        ],
                    },
                },
                {
                    backgroundImg: '14.jpg',
                    mapVisible: false,
                    microphone: false,
                    mapIcon: true,
                    MaskShow: true,
                    className: 'searchPos11',
                    visible: false,
                    hasVideo:true,
                    videoUrl:'http://www.artgogo.com/online-exhibition/mp4/sueoriginal.mp4',
                    videoBackgroundImg:'http://www.artgogo.com/online-exhibition/img/14.jpg',
                    carousel: [
                        {
                            num: 81,
                            artist: '曹启泰',
                            city: '上海',
                            title: '启泰画字-太确定-未来来',
                            size: '50*100cm',
                            caizhi: '纸面书法',
                            year: 2020,
                            href: 'http://www.artgogo.com/yishupin/2020-5-14_1589465158791.shtml',
                            img: 'http://www.artgogo.com/images/2020/5/14/1589465117emogphi90_a.jpg',
                            words:
                                '在中文里，简体、繁体，未来来三个字是一样的，很接近的结构。一个动作的长与短，就有完全不一样的意义出现。所以我们自己的长短、我们对事情努力的长短可以改变一切',
                        },
                        {
                            num: 80,
                            artist: 'Sue',
                            city: '武汉',
                            title: '“－定＋ ”',
                            size: null,
                            caizhi: '纸面数码摄影',
                            year: 2020,
                            words: '“定 ”有摇摆的意义，兩边的正负极象征着生活中不可控的萬變，安定與無常，美好與無奈……而我们在这之间寻求一种定力，用定力去面对各种不确定的演變。',
                            href: 'http://www.artgogo.com/yishupin/2020-5-15_1589527027703.shtml',
                            img: 'http://www.artgogo.com/yishupin/images/2020/5/18/20205181589777538329_395_a.jpeg',
                        },
                    ],
                },
                {
                    backgroundImg: '15.jpg',
                    mapVisible: false,
                    microphone: true,
                    ban: true,
                    lyric: [
                        {
                            time: '01',
                            words: 'Hello 大家好，我是万雨尘',
                        },
                        {
                            time: '03',
                            words: '在《末世之花》和《末世之森》里面',
                        },
                        {
                            time: '06',
                            words: '虽然看到的是末世的景象',
                        },
                        {
                            time: '09',
                            words: '但末世的景象之下总有生命力顽强的力量',
                        },
                        {
                            time: '13',
                            words: '你感受到希望了吗',
                        },
                        {
                            time: '016',
                            words: '也希望大家寻找这次展览里面',
                        },
                        {
                            time: '018',
                            words: '我的另外三幅作品哦',
                        },
                    ],
                    audioCont: ['http://www.artgogo.com/online-exhibition/haipai-music/wanyuchen.m4a'],
                    switchBanner: false,
                    mapIcon: true,
                    MaskShow: true,
                    className: 'searchPos12',
                    visible: false,
                    carousel: [
                        {
                            num: 70,
                            artist: '万雨尘',
                            city: '上海',
                            title: '末世之花',
                            size: '140*100cm',
                            caizhi: '布面微喷丙烯',
                            year: 2020,
                            words: '《末世之花》，《末世之森》,在此次疫情中，世界发生翻天覆地的变化，宛如末世的景象，但看见的是绝望还是希望，是窒息还是宁静，是取决于心。',
                            href: 'http://www.artgogo.com/yishupin/2020-3-30_158553775385.shtml',
                            img: 'http://www.artgogo.com/images/2020/3/30/1585537354alpic3220_a.jpg',
                        },
                        {
                            num: 69,
                            artist: '万雨尘',
                            city: '上海',
                            title: '末世之森',
                            size: '360*100cm',
                            caizhi: '布面微喷丙烯',
                            year: 2020,
                            words: '《末世之花》，《末世之森》,在此次疫情中，世界发生翻天覆地的变化，宛如末世的景象，但看见的是绝望还是希望，是窒息还是宁静，是取决于心。',
                            href: 'http://www.artgogo.com/yishupin/2020-3-30_1585537757441.shtml',
                            img: 'http://www.artgogo.com/images/2020/3/30/1585537356rmatogp95_a.jpg',
                        },
                    ],
                },
                {
                    backgroundImg: '16.jpg',
                    mapVisible: false,
                    microphone: false,
                    mapIcon: true,
                    MaskShow: true,
                    className: 'searchPos13',
                    visible: false,
                    carousel: [
                        {
                            num: 73,
                            artist: '史卢纯子',
                            city: '上海',
                            title: '细胞',
                            size: '60*80cm',
                            caizhi: '布面丙烯',
                            year: 2016,
                            words: '每个人在不同的经纬度都会相聚，就像这次疫情，全国各地的人民同心协力一起相聚战胜疫情',
                            href: 'http://www.artgogo.com/yishupin/2020-1-2_1577938152429.shtml',
                            img: 'http://www.artgogo.com/images/2020/1/2/1577938114derayps40_a.jpg',
                        },
                        {
                            num: 74,
                            artist: '史卢纯子',
                            city: '上海',
                            title: '人海',
                            size: '70*90cm',
                            caizhi: '布面丙烯',
                            year: 2019,
                            words: '每个人在不同的经纬度都会相聚，就像这次疫情，全国各地的人民同心协力一起相聚战胜疫情',
                            href: 'http://www.artgogo.com/yishupin/2020-1-2_1577935573667.shtml',
                            img: 'http://www.artgogo.com/images/2020/1/2/1577935459demaolhc4_a.jpg',
                        },
                        {
                            num: 86,
                            artist: '郭志鹏',
                            city: '上海',
                            title: '一面湖水',
                            size: '45*45*85cm',
                            caizhi: '不锈钢雕塑',
                            year: 2019,
                            words: '用平静的心情与臆想的境界合二为一，并赋予禅意的诠释 ',
                            href: 'http://www.artgogo.com/yishupin/2020-4-26_1587870505249.shtml',
                            img: 'http://www.artgogo.com/yishupin/images/2020/5/6/2020561588734943025_394_a.jpg',
                        },
                        {
                            num: 84,
                            artist: '陈濛婕',
                            city: '上海',
                            title: '温暖的风景1',
                            size: '213*78cm',
                            caizhi: '综合材料',
                            year: 2019,
                            words: '温暖的风景系列使用软材料展现独特的视觉效果，希望在此刻这份柔软可以让大家感受爱和温暖',
                            href: 'http://www.artgogo.com/yishupin/2020-5-6_158873528017.shtml',
                            img: 'http://www.artgogo.com/yishupin/images/2020/5/18/20205181589777409148_395_a.jpg',
                        },
                        {
                            num: 85,
                            artist: '陈濛婕',
                            city: '上海',
                            title: '温暖的风景2',
                            size: '213*78cm',
                            caizhi: '综合材料',
                            year: 2019,
                            words: '温暖的风景系列使用软材料展现独特的视觉效果，希望在此刻这份柔软可以让大家感受爱和温暖',
                            href: 'http://www.artgogo.com/yishupin/2020-5-6_1588735284631.shtml',
                            img: 'http://www.artgogo.com/yishupin/images/2020/5/18/20205181589777455715_395_a.jpg',
                        },
                        {
                            num: 75,
                            artist: '童振刚',
                            city: '北京',
                            title: '不稳定因素 第三组',
                            size: '25*22*39cm*6',
                            caizhi: '铜质雕塑',
                            year: 2015,
                            words: '塑造出神态各异的顽主形象，伫立于都市林立高楼间，构成一幅别样的景致',
                            href: 'http://www.artgogo.com/yishupin/2019-1-18_154778571622.shtml',
                            img: 'http://www.artgogo.com/images/2019/1/18/1547785606draolpis8_a.jpg',
                        },
                        {
                            num: 125,
                            artist: '周勇颉',
                            city: '上海',
                            title: '上海公交车',
                            size: '40*30cm',
                            caizhi: '布面油画',
                            year: 2019,
                            words: '再寻常不过的日常在特殊的日子显得尤为珍贵',
                            href: 'http://www.artgogo.com/yishupin/2020-5-6_1588735873938.shtml',
                            img: 'http://www.artgogo.com/images/2020/5/6/1588735784rgyhis832_a.jpg',
                        },
                        {
                            num: 126,
                            artist: '周勇颉',
                            city: '上海',
                            title: '童车',
                            size: '40*30cm',
                            caizhi: '布面油画',
                            year: 2019,
                            words: '再寻常不过的日常在特殊的日子显得尤为珍贵',
                            href: 'http://www.artgogo.com/yishupin/2020-5-6_1588735878892.shtml',
                            img: 'http://www.artgogo.com/images/2020/5/6/1588735785ermolp716_a.jpg',
                        },
                        {
                            num: 127,
                            artist: '周勇颉',
                            city: '上海',
                            title: '电扇',
                            size: '40*50cm',
                            caizhi: '布面油画',
                            year: 2019,
                            words: '再寻常不过的日常在特殊的日子显得尤为珍贵',
                            href: 'http://www.artgogo.com/yishupin/2020-5-6_158873586918.shtml',
                            img: 'http://www.artgogo.com/images/2020/5/6/1588735783datypics2_a.jpg',
                        },
                        {
                            num: 123,
                            artist: '张海浪',
                            city: '上海',
                            title: '唯爱永生',
                            size: '30*40cm',
                            caizhi: '布面油画',
                            year: 2019,
                            words: '艺术家的人物画作都有一个统一的特征，画作中的人物总是由内向外凝视着世界，“用画作与观赏者对视的方式，驱逐观赏者内心的孤立感。',
                            href: 'http://www.artgogo.com/yishupin/2020-4-23_1587610535664.shtml',
                            img: 'http://www.artgogo.com/images/2020/4/23/1587610464emagi1562_a.jpg',
                        },
                        {
                            num: 124,
                            artist: '张海浪',
                            city: '上海',
                            title: '婚姻故事',
                            size: '50*70cm',
                            caizhi: '布面油画',
                            year: 2019,
                            words: '在一对夫妻或而交替凝视，或而避开的眼神中，或多或少透露出二者之间埋藏在心底的一些隐秘情愫，这种情绪堆积如山，是被广泛认知为的—关系。',
                            href: 'http://www.artgogo.com/yishupin/2020-4-23_158761053933.shtml',
                            img: 'http://www.artgogo.com/images/2020/4/23/1587610466moglhcs35_a.jpg',
                        },
                        {
                            num: 87,
                            artist: '陈志泽',
                            city: '北京',
                            title: '清晨',
                            size: '60*40cm',
                            caizhi: '布面综合材料',
                            year: 2020,
                            words:
                                '作品表述的不仅仅是自我情感，还包括了现实中大部分人都有的生活与心理状态，我将宁静、激情与压抑后的释放主观凝集在作品里，我相信他们可以代替我传递我的温度。 这个作品中的两个小动物可以随意摆放，观众可以参与其中，摆放到任何的位置，产生出不同的效果，作品本身是对传统架上绘画的进一步思考，使其产生更多的可能性。',
                            href: 'http://www.artgogo.com/yishupin/2020-4-24_1587723088147.shtml',
                            img: 'http://www.artgogo.com/images/2020/4/24/1587722998maglpis58_a.jpg',
                        },
                        {
                            num: 98,
                            artist: '万艺',
                            city: '北京',
                            title: '梯',
                            size: '23*23.5cm',
                            caizhi: '布面综合材料',
                            year: 2018,
                            words:
                                '每个明天都会成为昨天，每个今天都是明天的先行者，努力做好“今天”发生的事，珍惜“今天”与你相伴相遇的人，真诚勇敢面对发生的不确定的一切，是每一位时光旅行者应掌握的必备技能。',
                            href: 'http://www.artgogo.com/yishupin/2020-4-24_1587723091416.shtml',
                            img: 'http://www.artgogo.com/images/2020/4/24/1587722999eaolpic04_a.jpg',
                        },
                        {
                            num: 122,
                            artist: '张海坤',
                            city: '上海',
                            title: '左也无鹿，右也无鹿',
                            size: '33*40*21cm',
                            caizhi: '树脂雕塑',
                            year: 2020,
                            words: '鹿代表着幸运，树叶代表着生命，全世界被疫情的阴霾笼罩，希望这个作品可以从这件作品看到希望。',
                            href: 'http://www.artgogo.com/yishupin/2020-2-9_1581247834508.shtml',
                            img: 'http://www.artgogo.com/images/2020/2/9/1581247727maogps724_a.jpg',
                        },
                        {
                            num: 92,
                            artist: '曾文幽',
                            city: '上海',
                            title: '地球的吹哨“人”',
                            size: '42*42cm',
                            caizhi: '纸面水墨',
                            year: 2020,
                            words: '企鹅作品源于疫情期间南极出现异常的红藻，是地球生态发出的警告，人类没有生活在南极，但企鹅知道',
                            href: 'http://www.artgogo.com/yishupin/2020-4-23_1587611439996.shtml',
                            img: 'http://www.artgogo.com/images/2020/4/23/1587611273demaglh20_a.jpg',
                        },
                        {
                            num: 93,
                            artist: '曾文幽',
                            city: '上海',
                            title: '进化',
                            size: '42*42cm',
                            caizhi: '纸面水墨',
                            year: 2020,
                            words: '企鹅作品源于疫情期间南极出现异常的红藻，是地球生态发出的警告，人类没有生活在南极，但企鹅知道',
                            href: 'http://www.artgogo.com/yishupin/2020-4-23_1587611444664.shtml',
                            img: 'http://www.artgogo.com/images/2020/4/23/1587611275eatglhs49_a.jpg',
                        },
                        {
                            num: 94,
                            artist: '刘秀真',
                            city: '上海',
                            title: '桃喜',
                            size: '38x38cm',
                            caizhi: '纸面国画',
                            year: 2020,
                            words: '物极必反、否极泰来，寒冬总会过去；暖春迟早到来。桃，讨也，今桃花盛放，鹊笑鸠舞，是谓桃喜之日。',
                            href: 'http://www.artgogo.com/yishupin/2020-4-24_1587724050946.shtml',
                            img: 'http://www.artgogo.com/images/2020/4/24/1587723990demtgyic6_a.jpg',
                        },
                    ],
                },
                {
                    backgroundImg: '17.jpg',
                    mapVisible: false,
                    microphone: true,
                    ban: true,
                    lyric: [
                        {
                            time: '01',
                            words: '希望你在这个展览里面看到了疫情一开始',
                        },
                        {
                            time: '04',
                            words: '疫情的后来',
                        },
                        {
                            time: '05',
                            words: ' 疫情的现在',
                        },
                        {
                            time: '07',
                            words: '希望你看到自己的心里走过的那条路',
                        },
                    ],
                    audioCont: ['http://www.artgogo.com/online-exhibition/haipai-music/cao-4.m4a'],
                    switchBanner: false,
                    mapIcon: true,
                    MaskShow: true,
                    className: 'searchPos14',
                    visible: false,
                    carousel: [
                        {
                            num: 95,
                            artist: '刘秀真',
                            city: '上海',
                            title: '云水情境',
                            size: '53*80cm',
                            caizhi: '纸面国画',
                            year: 2016,
                            words: '我们的确要自我反省，我们对大自然真的索取了太多。云水虽无言，但总能用它的方式来教训人类，而这代价太昂贵。',
                            href: 'http://www.artgogo.com/yishupin/2020-4-24_1587724156439.shtml',
                            img: 'http://www.artgogo.com/images/2020/4/24/1587724115dmatgli19_a.jpg',
                        },
                        {
                            num: 55,
                            artist: '刘秀真',
                            city: '上海',
                            title: '裂变之二四',
                            size: '52*140cm',
                            caizhi: '纸面国画',
                            year: 1999,
                            words: '人类直接不应处处竞争、杀伐，而更应该互帮互助，打造真正的人类命运共同体，才是万世长荣的和谐之道。',
                            href: 'http://www.artgogo.com/yishupin/2020-4-24_1587723952691.shtml',
                            img: 'http://www.artgogo.com//images/2020/4/24/1587723873emagics20_a.jpg',
                        },
                        {
                            num: 117,
                            artist: '迟宝绿',
                            city: '上海',
                            title: '粉色星球',
                            size: '30*40*10cm',
                            caizhi: '综合材料装置',
                            year: 2019,
                            words: '是一种梦想和希望，无论世界面临什么样的疫情问题，都存在希望，会变得越来越好。   ',
                            href: 'http://www.artgogo.com/yishupin/2020-4-26_1587869465196.shtml',
                            img: 'http://www.artgogo.com/images/2020/4/26/1587869345dermtg649_a.jpg',
                        },
                        {
                            num: 118,
                            artist: '迟宝绿',
                            city: '上海',
                            title: '城市派对',
                            size: '25*25*10cm',
                            caizhi: '综合材料装置',
                            year: 2019,
                            words: '这个城市就像一个舞台，我们都是其中的一部分。',
                            href: 'http://www.artgogo.com/yishupin/2020-4-26_158786945741.shtml',
                            img: 'http://www.artgogo.com/images/2020/4/26/1587869342ratgpic57_a.jpg',
                        },
                        {
                            num: 119,
                            artist: '迟宝绿',
                            city: '上海',
                            title: '闹情绪',
                            size: '26*35*8cm',
                            caizhi: '综合材料装置',
                            year: 2019,
                            words: '火焰是一种情绪，灼烧便是一种情绪的释放，当我们面对疫情的艰难时，展现的是一种勇气和果敢',
                            href: 'http://www.artgogo.com/yishupin/2020-4-26_1587869474214.shtml',
                            img: 'http://www.artgogo.com/images/2020/4/26/1587869348rmalyps64_a.jpg',
                        },
                        {
                            num: 72,
                            artist: '万雨尘',
                            city: '上海',
                            title: '庆祝是选择',
                            size: '44*59cm',
                            caizhi: '纸面油画',
                            year: 2020,
                            words: '《庆祝是选择》,生活是一种样子，但庆祝是选择。越是逆境，越需要看见总是有自己鼓励自己的选择。',
                            href: 'http://www.artgogo.com/yishupin/2020-3-30_1585537766807.shtml',
                            img: 'http://www.artgogo.com/images/2020/3/30/1585537359eglyics23_a.jpg',
                        },
                        {
                            num: 88,
                            artist: '卜金',
                            city: '上海',
                            title: '《幻》No.17',
                            size: '80*150cm',
                            caizhi: '布面油画',
                            year: null,
                            words: '山总是带给人稳固、刚毅，壮美之感，而我看到了一种沉默中的希望在混沌中闪光。',
                            href: 'http://www.artgogo.com/yishupin/2020-4-23_1587629110820.shtml',
                            img: 'http://www.artgogo.com/yishupin/images/2020/5/14/20205141589451097158_394_a.jpg',
                        },
                        {
                            num: 89,
                            artist: '卜金',
                            city: '上海',
                            title: '《幻》No.7',
                            size: '120*90cm',
                            caizhi: '布面油画',
                            year: 2020,
                            words: '山总是带给人稳固、刚毅，壮美之感，而我看到了一种沉默中的希望在混沌中闪光。',
                            href: 'http://www.artgogo.com/yishupin/2020-4-23_1587629115446.shtml',
                            img: 'http://www.artgogo.com/yishupin/images/2020/5/14/20205141589451033346_394_a.jpg',
                        },
                        {
                            num: 96,
                            artist: 'AI',
                            city: '上海',
                            title: 'through the end times I',
                            size: '120*140cm',
                            caizhi: '布面综合材料',
                            year: 2020,
                            words: '我在一个海岛看到在同一个海面暴风雨和夕阳下山同时出现的罕见画面，感叹风暴灾难的同时总是会有美丽诞生',
                            href: 'http://www.artgogo.com/yishupin/2020-4-2_1585815776982.shtml',
                            img: 'http://www.artgogo.com/images/2020/4/2/1585815706matopcs05_a.jpg',
                        },
                        {
                            num: 97,
                            artist: 'AI',
                            city: '上海',
                            title: 'through the end times II',
                            size: '120*140cm',
                            caizhi: '布面综合材料',
                            year: 2020,
                            words: '我在一个海岛看到在同一个海面暴风雨和夕阳下山同时出现的罕见画面，感叹风暴灾难的同时总是会有美丽诞生',
                            href: 'http://www.artgogo.com/yishupin/2020-4-2_1585815781275.shtml',
                            img: 'http://www.artgogo.com/images/2020/4/2/1585815709eratgis23_a.jpg',
                        },
                    ],
                },
                {
                    backgroundImg: '19.jpg',
                    mapVisible: false,
                    microphone: false,
                    mapIcon: true,
                    MaskShow: true,
                    classNameOne: 'searchPos16',
                    classNameTwo: 'searchPos16-1',
                    hasHandler: true,
                    peter: {
                        num: 120,
                        artist: '王香蕉',
                        city: '上海',
                        title: '三只小猪',
                        size: '180*90cm',
                        caizhi: '布面丙烯',
                        year: 2019,
                        words: '借助童话故事象征这次勤奋勇敢团结面对疫情的人们，这样才能战胜疫情',
                        href: 'http://www.artgogo.com/yishupin/2020-4-23_1587613628652.shtml',
                        img: 'http://www.artgogo.com/images/2020/4/23/1587613580maglyis17_a.jpg',
                    },
                    yangdifei: {
                        num: 121,
                        artist: '王香蕉',
                        city: '上海',
                        title: '青蛙王子',
                        size: '180*90cm',
                        caizhi: '布面丙烯',
                        year: 2019,
                        words: '借助童话故事，不要被一些事物的外表所欺骗，你以为的，可能并不是你所想象的那样。',
                        href: 'http://www.artgogo.com/yishupin/2020-4-23_1587613633423.shtml',
                        img: 'http://www.artgogo.com/images/2020/4/23/1587613583emlypis36_a.jpg',
                    },
                },
                {
                    backgroundImg: '18.jpg',
                    mapVisible: false,
                    microphone: false,
                    mapIcon: true,
                    MaskShow: true,
                    visible: false,
                    className: 'searchPos15',
                    showFallMess: {},
                    carousel: [
                        {
                        num: 91,
                        artist: 'Ikky Lin',
                        city: '上海',
                        title: '百雀朝凤图',
                        size: '400*150cm',
                        caizhi: '布面丙烯',
                        year: 2018,
                        href: 'http://www.artgogo.com/yishupin/2020-3-31_1585629874709.shtml',
                        img: 'http://www.artgogo.com/images/2020/3/31/1585629033ratgyhs00_a.jpg',
                        words: '期望未来我们的世界 百鸟朝凤 国泰民安 山河无恙\t',
                    },
                    {
                            num: 90,
                            artist: 'Ikky Lin',
                            city: '上海',
                            title: '天上天下',
                            size: '240*200cm',

                            caizhi: '布面丙烯',
                            year: 2019,
                            words: '天地山水之间万物和谐共生',
                            href: 'http://www.artgogo.com/yishupin/2020-5-6_1588734321682.shtml',
                            img: 'http://www.artgogo.com/images/2020/5/6/1588734277emglh7176_a.jpg',
                        }
                    ],
                },

                {
                    backgroundImg: '20.jpg',
                    mapVisible: false,
                    microphone: false,
                    ban: true,
                    lyric1: [
                        {
                            time: '01',
                            words: 'Hello 大家好，我是罗汉维',
                        },
                        {
                            time: '03',
                            words: '《太阳出来了》和《呐喊》这两幅作品',
                        },
                        {
                            time: '06',
                            words: '我依然用涂鸦的绘画方式来创作',
                        },
                        {
                            time: '08',
                            words: '对于我而言',
                        },
                        {
                            time: '010',
                            words: '不论外部世界怎样变化',
                        },
                        {
                            time: '012',
                            words: '不论到什么时候 ',
                        },
                        {
                            time: '014',
                            words: '我们依然可以用一个孩子的视角 ',
                        },
                        {
                            time: '016',
                            words: '去面对周遭的一切',
                        },
                        {
                            time: '018',
                            words: '愿内心永远保有那一份纯真和美好',
                        },
                    ],
                    audioCont1: ['http://www.artgogo.com/online-exhibition/haipai-music/luohanwei.mp3'],
                    switchBanner: false,
                    mapIcon: true,
                    MaskShow: true,
                    visibleOne: false,
                    classNameOne: 'searchPos17',
                    carouselOne: [
                        {
                            num: 83,
                            artist: '罗汉维STOS',
                            city: '云南',
                            title: '太阳出来了',
                            size: '100*100cm',
                            caizhi: '布面丙烯',
                            year: 2020,
                            words: '“阴霾总会过去，阳光也终将到来”，我们依然可以用一颗孩子的心态，期待着美好世界的到来… ',
                            href: 'http://www.artgogo.com/yishupin/2020-5-8_1588913704987.shtml',
                            img: 'http://www.artgogo.com/images/2020/5/8/1588913631matis6323_a.jpg',
                        },
                        {
                            num: 82,
                            artist: '罗汉维STOS',
                            city: '云南',
                            title: '呐喊  The Scream',
                            size: '100*120cm',
                            caizhi: '布面丙烯',
                            year: 2019,
                            words: '每个人的内心都会发出自己呐喊，它们无声，但又比真实的声音更有力量，像是内心的呐喊终将指引每一个正在行动的人。',
                            href: 'http://www.artgogo.com/yishupin/2020-2-13_1581597388318.shtml',
                            img: 'http://www.artgogo.com/images/2020/2/13/1581597329dmtogyp50_a.jpg',
                        },
                        {
                            num: 128,
                            artist: '李熙慧',
                            city: '上海',
                            title: '束',
                            size: '50*90cm',
                            caizhi: '综合材料',
                            year: 2019,
                            words: '有时候，紧束只是为了更自由的伸展；成为一束，紧紧抱住，一起面对美丽和死亡',
                            href: 'http://www.artgogo.com/yishupin/2020-4-14_158685750429.shtml',
                            img: 'http://www.artgogo.com/images/2020/4/14/1586857454drmagics3_a.jpg',
                        },
                        {
                            num: 67,
                            artist: '万雨尘',
                            city: '上海',
                            title: '神女无常',
                            size: '31*39cm',
                            caizhi: '数码微喷',
                            year: 2020,
                            words: '《神女无常》:我们总是感叹世事的变换，但无常才是不变的本质。无常并不可怕，反而是生机与悲悯并存的存在。',
                            href: 'http://www.artgogo.com/yishupin/2020-3-30_158553776054.shtml',
                            img: 'http://www.artgogo.com/images/2020/3/30/1585537357daolhcs46_a.jpg',
                        },
                        
                        {
                            num: 79,
                            artist: '张翀',
                            city: '上海',
                            title: '玫瑰',
                            size: '3.6*24.3*11cm',
                            caizhi: '显微镜切片',
                            year: 2019,
                            words: '我把玫瑰的每个部分都做了显微镜切片。试想如果我们不知道玫瑰长什么样的话，是否能够通过观察和组合这些细胞来得到一朵完整的玫瑰呢？',
                            href: 'http://www.artgogo.com/yishupin/2020-3-25_1585113897941.shtml',
                            img: 'http://www.artgogo.com/yishupin/images/2020/3/25/20203251585115803952_394_a.jpg',
                        },
                    ],
                },
                {
                    backgroundImg: '21.jpg',
                    mapVisible: false,
                    microphone: false,
                    mapIcon: true,
                    MaskShow: true,
                },
                {
                    backgroundImg: '21.jpg',
                    mapVisible: false,
                    microphone: false,
                    mapIcon: false,
                    MaskShow: true,
                    mingdan: true,
                },
                {
                    backgroundImg: '23.jpg',
                    mapVisible: false,
                    microphone: false,
                    mapIcon: false,
                    MaskShow: false,
                    artworkAlbum: true,
                },
                {
                    backgroundImg: '24.jpg',
                    mapVisible: false,
                    microphone: false,
                    mapIcon: false,
                    MaskShow: false
                },
                {
                    backgroundImg: '25.jpg',
                    mapVisible: false,
                    microphone: false,
                    mapIcon: false,
                    MaskShow: false,
                    hasNews:true,
                },
                {
                    backgroundImg: '1-1.jpg',
                    mapVisible: false,
                    microphone: false,
                    mapIcon: false,
                    MaskShow: false,
                    title: 'Thank You For Arting China',
                },
            ],
        };
    },
    mounted() {
        let that = this;
        this.$nextTick(function() {
            that.loadImages(that.preLoadingImg);
        });
    },
    methods: {
        loadImages(images) {
            let promiseAll = [],
                imgs = [],
                total = images.length;
            for (let i = 0; i < total; i++) {
                promiseAll[i] = new Promise((resolve, reject) => {
                    imgs[i] = new Image();
                    imgs[i].src = images[i];
                    imgs[i].onload = () => {
                        resolve(imgs[i]);
                    };
                    imgs[i].onerror = () => {};
                });
            }
            Promise.all(promiseAll).then((img) => {
                this.isLoading = false;
            });
        },
        // 去除轮播遮罩
        toshow(msg) {
            this.list[msg].MaskShow = false;
        },
        //改变麦克风状态
        changeMicrophoneState(idx, bans) {
            if (bans) {
                this.list[10].ban2 = !this.list[10].ban2;
                // 手动关闭当前语音后播放背景音乐
                if (this.list[10].ban2 == true && this.musicDom != null) {
                    this.musicDom.play();
                }
            } else {
                this.list[idx].ban = !this.list[idx].ban;
                // 手动关闭当前语音后播放背景音乐
                if (this.list[idx].ban == true && this.musicDom != null) {
                    this.musicDom.play();
                }
            }
        },
        //让所有的麦克风都变成斜杠状态, 保留当前点击的麦克风状态
        addBanClass(idx, bans) {
            //记录当前被点击的麦克风的状态
            if (bans) {
                this.curBan = this.list[10].ban2;
            } else {
                this.curBan = this.list[idx].ban;
            }

            let that = this;

            for (let i = 0; i < that.list.length; i++) {
                if (that.list[i].ban != undefined) {
                    that.list[i].ban = true;
                    that.list[10].ban2 = true;
                }
            }
            setTimeout(function() {
                if (bans) {
                    that.list[10].ban2 = that.curBan;
                } else {
                    that.list[idx].ban = that.curBan;
                }
            }, 100);
        },
        //让所有的麦克风都变成斜杠状态
        banAllMicroPhoneHandler() {
            let that = this;
            this.list[10].ban2 = true;
            for (let i = 0; i < that.list.length; i++) {
                if (that.list[i].ban != undefined) {
                    that.list[i].ban = true;
                }
            }
        },
        // 监听语音播放结束
        resetMicrophoneState(idx) {
            this.list[idx].ban = true;
            this.list[10].ban2 = true;
        },

        //记录背景音乐、添加旋转动画
        markBackgroundMusicHandler(music, idx) {
            this.musicDom = music;
            let musicPlayDom = document.getElementsByClassName('music-playbill');
            for (let i = 0; i < musicPlayDom.length; i++) {
                if (i != idx) {
                    document.getElementsByClassName('music-playbill')[i].classList.remove('play');
                } else {
                    document.getElementById(`musicPlay${idx}`).classList.add('play');
                }
            }
        },
        //清除背景音乐以及旋转动画
        clearnBackgroundMusicHandler(idx) {
            this.musicDom = null;
            document.getElementById(`musicPlay${idx}`).classList.remove('play');
        },
        // 背景音乐打断后继续播放
        playBackgroundMusicHandler() {
            if (this.musicDom != null) {
                this.musicDom.play();
            }
        },
        showDrawer(idx) {
            this.list[idx].visible = true;
        },
        onClose(idx) {
            this.list[idx].visible = false;
            this.list[idx].visibleOne = false;
            this.list[idx].visibleTwo = false;
        },
        showDrawerOne(idx) {
            this.list[idx].visibleOne = true;
        },
        showDrawerTwo(idx) {
            this.list[idx].visibleTwo = true;
        },
        stopBackgroundMusicHandler(){
            if (this.musicDom != null) {
                this.musicDom.pause();
               // console.log('stop musicDom')
            }
        },
         //记录点击的背景音乐index
        markMusicIndexHandler(idx){
            this.backgroundMusicIndex = idx
            for(let i = 0; i < this.musicData.length; i++){
                if(i == idx){
                    this.musicData[idx].state = true
                }else{
                    this.musicData[i].state = false
                }
            }            
        },
        // 更换下一首音乐
        changeMusic(){
            let that = this
            let music = document.getElementById('musicPlayBox')
            let backgroundMusic = music.getElementsByTagName('audio');
            //清除背景音乐以及旋转动画
            this.clearnBackgroundMusicHandler(this.backgroundMusicIndex)
            for(let i = 0; i < backgroundMusic.length; i++){
                backgroundMusic[i].pause()
            }
            that.backgroundMusicIndex++
            if(that.backgroundMusicIndex >= 3){
                that.backgroundMusicIndex = 0
            }
            backgroundMusic[that.backgroundMusicIndex].play()
            //记录背景音乐、添加旋转动画
            that.markBackgroundMusicHandler(backgroundMusic[that.backgroundMusicIndex],that.backgroundMusicIndex)
            this.musicDom = backgroundMusic[that.backgroundMusicIndex]
            
        }
    },
};
</script>
